
import pic from '@/utils/pic'
const { icon1, icon2, icon3, langzh, langen, langtw, langjp,langar, langxby,langdy,langfy,langhy,langty,langyn,zhsz, jtrz, sfrz, iconchecked, iconcheck,icon1_01,icon1_02,icon1_03,icon1_04,banner01,banner02,banner03 } = pic

export default {
  "公告详情":"Chi tiết thông báo",
  "未读":"Chưa đọc",
  "已读":"Đã đọc",
  "主动取消":"Hủy bỏ",
  "申请拒绝":"Từ chối đơn đăng ký",
  "赎回拒绝":"Sự từ chối cứu chuộc",
  "重新申请":"Áp dụng lại",
  "撤回申请":"Rút đơn",
  "在这里购买有潜力的":"Mua tiềm năng ở đây",
    "什么是新币申购？":"Đăng ký New Coin là gì?",
    "投资价值高":"Giá trị đầu tư cao",
    "新币价格低，潜在价值高，适合投资":"Đồng tiền mới có giá thấp và giá trị tiềm năng cao, thích hợp để đầu tư",
    "无手续费":"Không có phí xử lý",
    "购买新币不需要任何手续费":"Không cần phí khi mua tiền xu mới",
    "是交易产品中风险最低且收益稳定的一种投资方式":"Đây là phương pháp đầu tư có rủi ro thấp nhất và lợi nhuận ổn định trong số các sản phẩm giao dịch.",
    "产品":"sản phẩm",
    "我的申购订单":"Đơn đặt hàng của tôi",
    "总数量":"Tổng số lượng",
    "已认购量":"Số tiền đã đăng ký",
    "剩余数量":"Số lượng còn lại",
    "锁仓天数":"Những ngày bị khóa",
    "浅色模式":"Chế độ sáng",
    "深色模式":"Chế độ tối",
  "修改昵称":"Đổi biệt danh",
  "昵称":"Biệt danh",
  "头像":"Avatar",
  "绑定邮箱":"Liên kết email",
  "绑定手机号":"Liên kết số điện thoại",
  "未绑定":"Chưa liên kết",
  "上传头像":"Tải lên avatar",
  "修改头像":"Thay đổi avatar",
  "个人信息":"thông tin cá nhân",
  "我们发送了验证码至":"Chúng tôi đã gửi mã xác minh đến",
  "中":"trong",
  "请输入获取到的验证码以激活账户":"Vui lòng nhập mã xác minh để kích hoạt tài khoản",
    "请输入昵称":"Vui lòng nhập biệt danh của bạn",
    "手机号":"Số điện thoại",
    "邮箱号":"Địa chỉ email",
    "请输入邮箱号":"Vui lòng nhập địa chỉ email của bạn",
  "白皮书":"Giấy trắng",
  "驾驶证":"Giấy phép lái xe",
  "居住证":"Thẻ cư trú",
  "通过时间":"Thời gian xử lý",
  "银行账户":"Tài khoản ngân hàng",
    "请输入银行账户":"Vui lòng nhập số tài khoản ngân hàng.",
    "银行国际代码":"Mã SWIFT",
    "请输入国际代码":"Vui lòng nhập mã quốc tế.",
    "电话号码":"Số điện thoại",
    "请输入电话号码":"Vui lòng nhập số điện thoại của bạn",
    "上传房屋证明":"Tải lên bằng chứng nhà ở",
    "上传收入证明":"Tải lên bằng chứng thu nhập",
    "上传银行证明":"Tải lên bằng chứng ngân hàng",
    "上传证件照":"Tải lên ảnh ID",
    "提示:您可以通过上传证明来提高信用分":"Mẹo: Bạn có thể cải thiện điểm tín dụng của mình bằng cách tải lên bằng chứng",
    "谷歌验证码":"Mã xác minh Google",
    "修改谷歌验证码":"Chỉnh sửa mã xác minh Google",
    "扫描二维码绑定":"Quét mã QR để liên kết",
    "输入验证码":"Nhập mã xác minh",
    "你知道吗？":"Bạn có biết không?",
    "绑定2FA认证,提款时需要取得您的认证,资金更安全":"Liên kết xác thực 2FA, cần xác thực của bạn khi rút tiền, an toàn hơn cho tài chính",
    "立即绑定":"Liên kết ngay",
    "请输入原绑定的谷歌验证码":"Nhập mã xác minh Google ban đầu",
    "重新绑定":"Liên kết lại",
    "交易密码":"Mật khẩu giao dịch",
    "请输入交易密码":"Vui lòng nhập mật khẩu",
    "请输入谷歌验证码":"Vui lòng nhập mã Google",
    "请到安全中心设置交易密码":"Đặt mật khẩu giao dịch trong trung tâm bảo mật",
    "请到安全中心设置谷歌验证":"Đặt xác minh Google trong trung tâm bảo mật",
    "请输入验证码":"Vui lòng nhập mã",
    "信用分":"Điểm tín dụng",

  "关闭":"Đóng",
  "查看详情":"Xem chi tiết",
  "向卖家付款":"Trả tiền cho người bán",
    "获取您的币种":"Nhận tiền tệ của bạn",
    "我的订单":"Đơn hàng của tôi",
    "未匹配":"Không khớp",
    "已匹配":"Đã khớp",
    "已完成":"Hoàn thành",
    "已过期":"Hết hạn",
    "合同号":"Số hợp đồng",
      "买入金额":"Số lượng mua",
      "邮箱":"Thư",
      "请输入您的电子邮箱":"Vui lòng nhập địa chỉ email của bạn",
      "请选择购买的货币":"Vui lòng chọn loại tiền bạn muốn mua",
      "请选择支付的货币":"Vui lòng chọn loại tiền tệ thanh toán",
      "请填写您的收款信息，如有需要补充信息请填写到备注栏或者联系客服。":"Vui lòng điền thông tin thanh toán của bạn. Nếu bạn cần thêm thông tin, vui lòng điền vào cột ghi chú hoặc liên hệ với bộ phận chăm sóc khách hàng.",
      "备注":"Nhận xét",
      "请选择币种":"Vui lòng chọn loại tiền tệ",
      "请输入钱包地址":"Vui lòng nhập địa chỉ ví của bạn",
      "绑定钱包":"Ví ràng buộc",
      "钱包地址":"Địa chỉ ví",
      "请输入备注":"Vui lòng nhập bình luận",
      "提现地址":"Địa chỉ rút tiền",
      "添加钱包地址":"Thêm địa chỉ ví",
      "钱包管理":"Quản lý ví",
    "重要提示：":"Mẹo quan trọng:",
    "订单有效期：买方或卖方需在发起订单后3小时内完成交易。如未能完成，请及时联系在线客服确认订单状态。":"Thời hạn hiệu lực của đơn hàng: Người mua hoặc người bán phải hoàn tất giao dịch trong vòng 3 giờ sau khi bắt đầu đơn hàng. Nếu không hoàn tất được, vui lòng liên hệ với bộ phận chăm sóc khách hàng trực tuyến kịp thời để xác nhận trạng thái đơn hàng.",
    "订单失效：若未在规定时间内联系客服，订单将自动失效，无法恢复。":"Đơn hàng hết hạn: Nếu bạn không liên hệ với bộ phận chăm sóc khách hàng trong thời gian quy định, đơn hàng sẽ tự động hết hạn và không thể khôi phục.",
    "安全保障：我们提供全面的交易保障措施，确保您的资金和交易信息安全。":"Bảo mật: Chúng tôi cung cấp các biện pháp bảo vệ giao dịch toàn diện để đảm bảo an toàn cho tiền và thông tin giao dịch của bạn.",

    "充值":"Tiền gửi",
    "提现":"Rút",
    "兑换":"Trao đổi",
    "今日收益":"L&L (Hôm nay)",
    "现金":"tiền mặt",
    "交易":"buôn bán",
    "理财":"quản lý tài chính",
    "资产列表":"Danh sách tài sản",
  "已锁仓":"Đã khóa",
  "最高可贷款":"Số tiền vay tối đa",
  "请先完成高级认证":"Vui lòng hoàn tất xác minh nâng cao",
  "贷款金额":"Số tiền vay",
  "总还款额":"Tổng số tiền hoàn trả",
  "金融":"Tài chính",
  "选择周期":"Chọn chu kỳ",
  "选择类型":"Chọn Loại",
  "结算价":"Giá thanh toán",
  "限价卖出":"Giới hạn bán",
  "截止价卖出":"Dừng bán",
  "加密货币":"Tiền điện tử",
  "银行卡":"Thẻ ngân hàng",
  "金额":"Số lượng",
  "选择银行":"Chọn Ngân hàng",
  "提款需要的手续费,这需要由网络节点确认, 才能记入请不要将加密货币转让给陌生人":"Phí rút tiền cần được nút mạng xác nhận trước khi có thể được ghi có. Vui lòng không chuyển tiền điện tử cho người lạ",
  "银行卡管理":"Quản lý thẻ ngân hàng",
  "绑定银行卡":"Liên kết thẻ ngân hàng",
  "添加":"Thêm vào",
  "添加银行卡":"Thêm thẻ ngân hàng",
  "修改银行卡":"Sửa đổi thẻ ngân hàng",
  "请添加银行卡":"Vui lòng thêm thẻ ngân hàng",
  "数量":"Số lượng",
  "继续下单":"Tiếp tục",
  "路由号码":"Número de ruta",
  "请输入路由号码":"Vui lòng nhập số định tuyến",
  "搜索":"tìm kiếm",

  "限价买入":"Giới hạn mua",
  "截止价买入":"Dừng giá Mua",
  "限价卖出":"Giới hạn bán",
  "截止价卖出":"Dừng bán",
  "贷款金额":"Số tiền vay",
  "总还款额":"Tổng số tiền hoàn trả",
  "委托总量":"Tổng cộng",
  "交易总额":"tổng số tiền giao dịch",
  "成交价格":"Giá giao dịch",
  "委托价格":"Giá hoa hồng",
  "顶尖交易技术":"Công nghệ giao dịch hàng đầu",
  "通过我们的先进交易系统，您可以精准把握市场动态，高效执行每一笔交易！":"Thông qua hệ thống giao dịch tiên tiến của chúng tôi, bạn có thể nắm bắt chính xác động lực thị trường và thực hiện mọi giao dịch một cách hiệu quả!",
  "累计收入":"Thu nhập tích lũy",
    "每日收益":"Thu nhập hàng ngày",
    "助您探索更多交易机会和":"Giúp bạn khám phá thêm nhiều cơ hội giao dịch và",
    "金融产品":"Sản phẩm tài chính",
    "什么是活期借贷？":"Vay theo yêu cầu là gì?",
    "累计利息":"Lãi suất tích lũy",
    "申请金额":"Số lượng ứng dụng",
  "风险":"Rủi ro",
  "审核结果":"Kết quả kiểm tra",
  "您的等级为":"Mức độ của bạn là",
  "未评估":"Chưa được đánh giá",
  "谨慎性":"Thận trọng",
  "稳健型":"Ổn định",
  "进取型":"Năng động",
  "提示：您的风险承受为谨慎型，最高投资额为":"Lưu ý: Khả năng chịu rủi ro của bạn là thận trọng, số tiền đầu tư tối đa là",
  "如果您想提高额度请重新评估或联系客服":"Nếu bạn muốn tăng hạn mức, vui lòng đánh giá lại hoặc liên hệ với dịch vụ khách hàng",
  "重新评估":"Đánh giá lại",
  "验证中,请耐心等待系统审核":"Đang xác minh, vui lòng chờ đợi hệ thống kiểm tra",
  "确保符合平台的合规要求并完成您的投资者资格认证,我们需要您提供以下信息,请放心,您提供的所有资料将储存在我们高度加密和安全的资料库中,完全符合国际安全标准。我们非常重视您的资讯隐私,未经您的明确同意,绝不外泄或者分享这些资料":"Để đảm bảo tuân thủ các yêu cầu quy định của nền tảng và hoàn thành chứng nhận tư cách nhà đầu tư của bạn, chúng tôi cần bạn cung cấp các thông tin sau, xin yên tâm rằng tất cả thông tin bạn cung cấp sẽ được lưu trữ trong cơ sở dữ liệu được mã hóa cao và an toàn của chúng tôi, hoàn toàn phù hợp với tiêu chuẩn an toàn quốc tế. Chúng tôi rất coi trọng quyền riêng tư của thông tin của bạn, và sẽ không tiết lộ hoặc chia sẻ thông tin này mà không có sự đồng ý rõ ràng của bạn.",
  "了解产品":"Tìm hiểu sản phẩm",
  "C2C快捷买币只要三个":"C2C mua coin nhanh chỉ cần ba bước",
  "步骤完成":"Các bước đã hoàn thành",
  "什么是C2C?":"C2C là gì?",
  "请输入付款银行名称":"Vui lòng nhập tên ngân hàng thanh toán",
  "请选择币种":"Vui lòng chọn loại tiền tệ",
  "查看订单":"Xem đơn hàng",
  "查看汇款账号":"Xem số tài khoản chuyển tiền",
  "订单金额":"Số tiền đơn hàng",
  "卖家收款账号":"Số tài khoản nhận tiền của người bán",
  "账户名称":"Tên tài khoản",
  "账户号":"Số tài khoản",
  "银行名称":"Tên ngân hàng",
  "银行地址":"Địa chỉ ngân hàng",
  "距离本次电汇订单有效期还剩":"Thời gian còn lại cho đơn hàng chuyển tiền này",
  "买入金额":"Số tiền mua vào",
  "查看汇款账号":"Xem số tài khoản chuyển tiền",
  "请输入订单号":"Vui lòng nhập số đơn hàng",
  "职业":"Nghề nghiệp",
  "请输入职业":"Vui lòng nhập nghề nghiệp",
  "财富来源":"Nguồn tài sản",
  "请输入财富来源":"Vui lòng nhập nguồn tài sản",
  "预期投资金额":"Số tiền đầu tư dự kiến",
  "请输入预期投资金额":"Vui lòng nhập số tiền đầu tư dự kiến",
  "资产证明":"Bằng chứng tài sản",
  "请上传资产证明":"Vui lòng tải lên bằng chứng tài sản",
  "借贷":"Cho vay",
  "我的贷款订单":"Đơn vay của tôi",
  "借贷金额":"Số tiền vay",
  "可借额度":"Hạn mức có thể vay",
  "借贷天数":"Số ngày vay",
  "请选择天数":"Vui lòng chọn số ngày",
  "立即借币":"Vay coin ngay lập tức",
  "当前借贷":"Vay hiện tại",
  "当前信用分":"Điểm tín dụng hiện tại",
  "还款总额":"Tổng số tiền trả nợ",
  "还款日期":"Ngày trả nợ",
  "产品亮点":"Điểm nổi bật của sản phẩm",
  "超低利息":"Lãi suất siêu thấp",
  "为了回馈新老用户，平台借贷超低利息费用":"Để tri ân người dùng mới và cũ, nền tảng cho vay với lãi suất siêu thấp",
  "当天下发":"Chuyển khoản trong ngày",
  "当天贷款，最快当天下发至您的账户里":"Vay trong ngày, chuyển khoản nhanh nhất vào tài khoản của bạn trong ngày",
  "24小时在线客服":"Dịch vụ khách hàng trực tuyến 24 giờ",
  "24小时在线客服，满足您的贷款需求":"Dịch vụ khách hàng trực tuyến 24 giờ, đáp ứng nhu cầu vay của bạn",
  "产品规则":"Quy tắc sản phẩm",
  "单位":"Đơn vị",
  "获利":"Lợi nhuận",
  "稳健型ETF订单":"Đơn hàng ETF ổn định",
  "低风险ETF订单":"Đơn hàng ETF rủi ro thấp",
  "VIP理财订单":"Đơn hàng quản lý tài chính VIP",
  "输入地址":"Nhập địa chỉ",
  "购买":"Mua",
  "当前可用":"Hiện có sẵn",
  "请验证您的助记词以确认钱包所有权,然后提交您的加密地址":"Vui lòng xác minh cụm từ khôi phục của bạn để xác nhận quyền sở hữu ví, sau đó gửi địa chỉ mã hóa của bạn",
  "地址":"Địa chỉ",
  "验证码助记词":"Cụm từ khôi phục mã xác nhận",
  "产品亮点":"Điểm nổi bật của sản phẩm",
  "100%资金安全保障":"Đảm bảo an toàn 100% cho vốn",
  "我们致力于确保金融产品和服务对投资者公平":"Chúng tôi cam kết đảm bảo rằng các sản phẩm và dịch vụ tài chính công bằng đối với nhà đầu tư",
  "正规平台受政府监管":"Nền tảng hợp pháp được chính phủ quản lý",
  "我们主动接受各级政府监管和合规经营":"Chúng tôi chủ động chấp nhận sự quản lý của chính phủ ở mọi cấp và hoạt động tuân thủ",
  "当天起息":"Bắt đầu tính lãi trong ngày",
  "当天成功存入后，马上计算收益":"Sau khi gửi thành công trong ngày, sẽ ngay lập tức tính toán lợi nhuận",
  "加密钱包地址":"Địa chỉ ví mã hóa",
  "请输入助记词":"Vui lòng nhập cụm từ khôi phục",
  "助记词无效":"Cụm từ khôi phục không hợp lệ",
  "请输入钱包地址":"Vui lòng nhập địa chỉ ví",


  "存储人姓名":"Tên người gửi tiền",
  "付款银行名称":"Tên ngân hàng thanh toán",
  "买卖币种":"Mua và bán tiền tệ",
  "选择币种":"Chọn tiền tệ",
  "付款方式":"Phương thức thanh toán",
  "法币":"Tiền pháp định",
  "电汇":"T/T",
  "输入法币":"Đầu vào Tiền tệ Fiat",
  "存款金额":"Số tiền gửi",
  "请输入金额":"Vui lòng nhập số tiền",
  "上传汇款凭证":"Tải lên một bản sao của chuyển khoản",
  "请输入订单号":"Vui lòng nhập số đơn hàng của bạn",
  "低风险":"Rủi ro thấp",
  "稳健型":"Mạnh mẽ",
  "基金":"Quỹ",
  "类型":"Kiểu",
  "输入":"Đi vào",
  "立即参与":"tham gia",
  "什么是低风险ETF?":"ETF rủi ro thấp là gì?",
  "什么是稳健型ETF?":"ETF bảo thủ là gì?",
  "什么是VIP理财？":"Quản lý tài chính VIP là gì?",
  "买币流程":"Quy trình mua tiền tệ",
  "创建预订单":"Tạo đơn đặt hàng trước",
  "联系客服":"Dịch vụ khách hàng",
  "提交凭证":"Chứng chỉ",
  "创建订单":"Tạo đơn đặt hàng",
  "我们的优势":"Ưu điểm của chúng tôi",
  "低廉的交易费用":"Phí giao dịch thấp",
  "在我们的C2C买币上，下单方以零手续费交易，我承诺在所有市场用最低的C2C交易费用":"Với loại tiền tệ mua C2C của chúng tôi, bên đặt hàng giao dịch với mức phí giao dịch bằng không. Chúng tôi cam kết áp dụng mức phí giao dịch C2C thấp nhất trên mọi thị trường.",
  "多种支付方式":"Nhiều phương thức thanh toán",
  "点对点（C2C）交易允许卖家自由定义透明想要的付款方式，通过700多种支付方式买卖加密货币，包括银行转账、现金。":"Giao dịch ngang hàng (C2C) cho phép người bán tự do xác định phương thức thanh toán mà họ muốn. Mua và bán tiền điện tử với hơn 700 phương thức thanh toán, bao gồm chuyển khoản ngân hàng, tiền mặt.",
  "以您喜欢的价格交易":"Giao dịch với mức giá bạn muốn",
  "以您喜欢的价格自由买卖加密货币，从现有报价中买卖，或创建交易广告来设置您理想的价格":"Tự do mua và bán tiền điện tử với mức giá bạn muốn, mua và bán từ các báo giá hiện có hoặc tạo quảng cáo giao dịch để đặt mức giá lý tưởng của bạn",
  "C2C简介":"Giới thiệu về C2C",
  "开":"O",
  "收":"C",
  "高":"H",
  "低":"L",
  "指标":"Chỉ báo",
  "订单表":"Sổ lệnh",
  "最新成交":"Lịch sử giao dịch",
  "截止价":"giá dừng",
  "风险评估":"Dánh giá rủi ro",
  "C2C买币":"Mua coin C2C",
  "初级认证":"Chứng nhận chính",
  "高级认证":"Chứng nhận nâng cao",
  "升级":"Nâng cấp",
  "新币":"Startup",
  "全仓":"Kho đầy đủ",
  "可开数量":"Số lượng có sẵn",
  "现货交易":"hàng hóa mặt",
  "当前委托":"mở lệnh",
  "历史委托":"lịch sử đặt hàng",
  "投资组合":"danh mục đầu tư",
  "分配":"phân phát",
  "投资":"quản lý tài chính",
  "隐藏小额资产":"Ẩn tài sản nhỏ",
  "个人中心":"Trung tâm cá nhân",
  "交易手续费":"Phí giao dịch",
  "实时新闻":"Tin tức",
  "联系客服匹配订单":"Liên hệ dịch vụ khách hàng để khớp lệnh",
  "分":"m",
  "时":"h",
  "天":"d",
  "周":"w",
  "月":"Month",
  "年":"Year",
  "我的投资":"Ghi",
  "总投入":"Đầu tư tổng cộng",
  "待匹配":"Đang chờ khớp",
  "已匹配":"Đã khớp",
  "已完成":"Hoàn thành",
  "已拒绝":"Bị từ chối",
  "付款人姓名":"Tên người thanh toán",
  "请输入付款	银行名称":"Vui lòng nhập tên của ngân hàng thanh toán",
  "新币申购":"Lần phát hành đồng tiền mới",
  "会员投资产品":"Sản phẩm quản lý tài chính",
  "默认":"mặc định",
  "个人主页":"Trang chủ cá nhân",
  "住址":"Địa chỉ",
  "街道、楼号":"Đường, Tòa nhà số",
  "职业":"Nghề nghiệp",
  "请填写职业":"Hãy điền nghề nghiệp",
  "月收入":"Thu nhập hàng tháng",
  "请输入月收入":"Vui lòng nhập thu nhập hàng tháng",
  "财富来源":"Nguồn gốc của sự giàu có",
  "请输入财富来源":"Vui lòng nhập nguồn tài sản của bạn",
  "预期投资资金":"Quỹ đầu tư dự kiến",
  "请输入预期投资资金":"Vui lòng nhập số tiền đầu tư dự kiến",
  "资产证明":"Bằng chứng tài sản",
  "房屋证明":"Bằng chứng nhà",
  "银行存款证明":"Bằng chứng gửi tiền ngân hàng",
  "股票":"Cổ phiếu",
  "持有的公司证明":"Giấy chứng nhận công ty đã được giữ",
  "上传证明":"Tải lên bằng chứng",
  "提交":"Nộp",
  "VIP财务管理":"Tài chính VIP",
  "顶尖交易技术":"Công nghệ giao dịch hàng đầu",
  "通过我们的先进交易系统，您可以精准把握市场动态，高效执行每一笔交易！":"Thông qua hệ thống giao dịch tiên tiến của chúng tôi, bạn có thể nắm bắt chính xác động lực thị trường và thực hiện mọi giao dịch một cách hiệu quả!",
  "搬砖币种":"Tiền gạch",
  "VIP理财":"Tài chính VIP",
  "支付信息":"Thanh toán",
  "上传凭证":"Tải lên chứng từ",
  "支付方式":"Phương thức thanh toán",
  "继续":"Tiếp tục",
      "钱包地址":"Địa chỉ ví",
  "请填写地址":"Nhập địa chỉ ví",
  "累计收入":"Thu nhập tích lũy",
  "每日收益":"Thu nhập hàng ngày",
  "估值":"Đánh giá",
  "收益率":"Tỷ lệ lợi nhuận",
      "钱包":"cái ví",
      "账户":"Tài khoản",
      "投资金额":"Số tiền đầu tư",
      "提交助记词":"Gửi cụm từ ghi nhớ",
      "请验证助记词以确认钱包所有权，并提交加密地址":"Vui lòng xác minh mã ghi nhớ của bạn để xác nhận quyền sở hữu ví và gửi địa chỉ tiền điện tử của bạn.",
      "验证助记词":"Xác minh cụm từ ghi nhớ",
      "确认":"xác nhận",
      "请填写数量":"Vui lòng điền số lượng",
      "1.初始连接web3":"Kết nối ban đầu với web3",
      "2.建立区块链节点":"Thiết lập nút blockchain",
      "3.建立智能合约网络":"Thiết lập mạng lưới hợp đồng thông minh",
      "4.成功创建合约":"Tạo hợp đồng thành công",
      "5.启动验证":"Bắt đầu xác minh",
      "可开仓":"Ngắn",
      "语言":"Ngôn ngữ",
      "交易明细":"Chi tiết giao dịch",
      "杠杆倍数":"Đòn bẩy",
      "保证金":"Ký quỹ",
      "手续费":"Hoa hồng",
      "剩余保证金":"Ký quỹ còn lại",
      "开仓价格":"Giá vào",
      "开仓时间":"Thời gian mở",
      "盈亏":"Lãi/lỗ",
      "交易周期":"Thời hạn",
      "交易时间":"Dấu thời gian",
      "托管中":"Lưu trữ",
      "已赎回":"Đã đổi",
      "请输入付款银行名称":"Nhập tên ngân hàng thanh toán.",
      "请进行初级认证":"Vui lòng làm chứng nhận sơ cấp",
      "请进行高级认证":"Vui lòng xác nhận nâng cao",
      "重新认证":"Xác nhận lại",
      "查看汇款账号":"Xem tài khoản chuyển tiền",
      "电汇订单剩余有效期":"Thời hạn hiệu lực của lệnh T/T",
      "卖家收款账号":"Tài khoản của người bán",
      "账户名称":"Tên tài khoản",
      "账户号":"Số tài khoản",
      "复制":"Sao chép",
      "订单有效期为3小时，过期请联系客服":"Lệnh có hiệu lực trong 3 giờ, liên hệ với bộ phận hỗ trợ nếu hết hạn",
      "请上传汇款凭证":"Vui lòng tải lên bằng chứng chuyển tiền",
      "SWIFT代码":"Mã SWIFT",
      "限价":"Giới hạn",
      "限价买入":"Giới hạn mua",
      "截止价买入":"Dừng giá Mua",
      "提示：您的风险评估为":"Mẹo: Đánh giá rủi ro của bạn là",
      "请输入限价":"Vui lòng nhập giá giới hạn",
      "昨日收益":"thu nhập",
      "期权交易":"quyền chọn",
      "持仓":"Vị trí",
      "委托":"ủy nhiệm",
      "已平仓":"Đã đóng vị trí",
      "托管数量":"Số lượng",
  "dcwj":{
  	"homehq1":"Khám phá tiền điện tử, ngoại hối, kim loại quý và hơn thế nữa",
  	"homehq2":"Mua, bán và quản lý hàng trăm danh mục giao dịch một cách đơn giản và an toàn",
  	"homehq3":"Xem thêm tài sản",
  	"xbgm":"Hãy chú ý đến thời điểm mua xu mới. Bạn không thể mua chúng khi chúng hết hạn.",
  	"yzmjs":"Đã nhận được mã xác minh",
  	"jhzh":"Kích hoạt tài khoản",
  	"xyy":"Trang tiếp theo",
  	"qxz":"Vui lòng chọn",
    },
  "立即兑换":"sự mua lại",
  "获得":"sự mua lại",
  "消耗":"cạn kiệt",
  "jhzf":"Chúng tôi đã gửi mã xác minh đến {0}. Vui lòng sử dụng mã xác minh để kích hoạt tài khoản của bạn.",
  "一应俱全的金融交易体验":"Kinh nghiệm giao dịch tài chính toàn diện",
    "强大平台,超低点差,快速执行,专属支持":"Nền tảng mạnh mẽ, chênh lệch cực thấp, khớp lệnh nhanh, hỗ trợ độc quyền",
    "您可以信赖的经济人":"Một đại lý bạn có thể tin tưởng",
    "卓越的客户服务、透明的定价和最先进的平台方面建 立了卓越的声誉":"Tạo dựng danh tiếng nhờ dịch vụ khách hàng đặc biệt, giá cả minh bạch và nền tảng tiên tiến",
    "强大的交易技术专属体验":"Trải nghiệm độc quyền về công nghệ giao dịch mạnh mẽ",
    "与整体满意度最高的供应商交易差价合约，把握更好的交易时机":"Giao dịch CFD với các nhà cung cấp với mức độ hài lòng tổng thể cao nhất để có cơ hội giao dịch tốt hơn",
    "为什么选择FXLY？让我们的数字来说话":"Tại sao nên chọn FXLY.com? Con số của chúng tôi tự nói lên điều đó.",
  "还在找一位您可以信任的经纪商吗？":"Bạn vẫn đang tìm kiếm một nhà môi giới đáng tin cậy?",
    "1.创建和验证您的账户":"1. Tạo và xác minh tài khoản của bạn",
    "2.进行存款":"2. Thực hiện khoản tiền gửi đầu tiên của bạn",
    "3.找到合适您的交易":"3. Bạn đã sẵn sàng. Bắt đầu giao dịch",
  "交易者":"Người buôn bán",
    "每月活跃客户":"Khách hàng hoạt động hàng tháng",
    "每月交易量":"Khối lượng giao dịch hàng tháng",
    "每月提取金额":"Rút ra mỗi tháng",
    "加入成为全球660,000万多名交易者的一份子，选择利用FXLY.com进行交易吧。":"Tham gia cùng hơn 660.000 nhà giao dịch trên toàn thế giới đã chọn giao dịch với FXLY.com",
  "国家":"Quốc gia",
    "首页":"trang đầu",
    "交易市场":"thị trường giao dịch",
    "市场概览":"Tổng quan thị trường",
    "股票":"Cổ phần",
    "外汇":"Ngoại hối",
    "商品":"Hàng hóa",
    "加密货币":"Tiền điện tử",
    "交易":"buôn bán",
    "币币交易":"Giao dịch tiền điện tử",
    "合约交易":"giao dịch hợp đồng",
    "期权交易":"giao dịch quyền chọn",
    "教育":"giáo dục",
    "市场指南":"hướng dẫn thị trường",
    "股票交易":"giao dịch chứng khoán",
    "商品交易":"giao dịch hàng hóa",
    "外汇交易":"Giao dịch ngoại hối",
    "加密货币交易":"giao dịch tiền điện tử",
    "学习中心":"Trung tâm học tập",
    "交易基础知识":"Kiến thức giao dịch",
    "什么是差价合约":"CFD là gì",
    "交易术语表":"Thuật ngữ giao dịch",
    "交易策略指南":"Hướng dẫn giao dịch",
    "更多":"Hơn",
    "新闻":"tin tức",
    "热点新闻":"tin nóng",
    "关于我们":"về chúng tôi",
    "为何选择我们":"Tại sao chọn chúng tôi",
    "如何保证安全性":"Đảm bảo an toàn",
    "合规与法律":"Tuân thủ và pháp lý",
    "服务费用":"phí dịch vụ",
    "投诉程序":"Thủ tục khiếu nại",
    "条款政策":"Điều khoản và chính sách",
    "帮助与支持":"Trợ giúp và hỗ trợ",
    "指数":"chỉ mục",
    "请切换到真实账户":"Vui lòng chuyển sang tài khoản Live",
  "支持桌面端与移动端多种方式":"Hỗ trợ nhiều phương thức trên máy tính để bàn và thiết bị đầu cuối di động",
  "简单、快速、安全、合法":"Đơn giản, nhanh chóng, an toàn và hợp pháp",
  "免费客户咨询服务":"Dịch vụ tư vấn khách hàng miễn phí",
  "多种产品可供选择":"Sản phẩm đa dạng để lựa chọn",
  "下载应用程序":"Tải ứng dụng xuống",
  "24小时交易量":"Khối lượng giao dịch 24 giờ",
  "币种":"Tiền tệ",
  "交易者":"Thương nhân",
  "每月提取金额":"Số tiền rút hàng tháng",
  "亿":"B",
  "万":"M",
  "3000多种品类供您选择":"Hơn 3.000 danh mục cho bạn lựa chọn",
  "操作不熟练,试试模拟交易":"Nếu bạn không có kỹ năng vận hành, hãy thử giao dịch mô phỏng",
  "线上交易,请选择":"Đối với giao dịch trực tuyến, vui lòng chọn",
  "交易所":"trao đổi",
  "3000多种品类,包括加密货币,贵金属,外汇, 原油等等":"Hơn 3.000 danh mục, bao gồm tiền điện tử, kim loại quý, ngoại hối, dầu thô, v.v.",
  "立即交易":"Giao dịch ngay bây giờ",
  "希望增进您的交易技巧":"Muốn cải thiện kỹ năng giao dịch của bạn",
  "访问我们的帮助中心,获取全面交易指南":"Truy cập Trung tâm trợ giúp của chúng tôi để có hướng dẫn giao dịch toàn diện",
  "去看看":"Đi và nhìn xem",
  "操作不熟练,试试我们的模拟交易功能":"Nếu bạn không có kỹ năng vận hành, hãy thử chức năng giao dịch mô phỏng của chúng tôi",
  "免费体验交易,让您尽快上手":"Hãy thử giao dịch miễn phí để bạn có thể bắt đầu càng sớm càng tốt",
  "马上体验":"Hãy thử ngay bây giờ",
  "充币":"Gửi tiền xu",
  "提币":"Rút xu",
  "客服":"dịch vụ khách hàng",
  "更多":"Hơn",
  "热门品种":"Giống phổ biến",
  "卖出":"bán",
  "买入":"mua",
  "了解我们的平台":"Tìm hiểu về nền tảng của chúng tôi",
  "直观易用":"Trực quan và dễ sử dụng",
  "的界面":"giao diện",
  "定期提供":"Cung cấp thường xuyên",
  "3,000多个市场":"Hơn 3.000 thị trường",
  "的实时更新和 价格警报":"Cập nhật trực tiếp và thông báo giá cho",
  "各种技术指标":"Các chỉ số kỹ thuật khác nhau",
  "分析工具和高级图表":"Công cụ phân tích và biểu đồ nâng cao",
  "套期保值模式和":"mô hình phòng ngừa rủi ro và",
  "风险管理工具":"công cụ quản lý rủi ro",
  "我们创建了技术领先且人性化的交易平台 ,为您提供贴心完善的交易体验":"Chúng tôi đã tạo ra một nền tảng giao dịch thân thiện với người dùng và công nghệ tiên tiến để cung cấp cho bạn trải nghiệm giao dịch chu đáo và đầy đủ.",
  "实时新闻咨询":"Tư vấn tin tức theo thời gian thực",
  "紧跟我们的新闻、产品和活动信息":"Luôn cập nhật tin tức, sản phẩm và sự kiện của chúng tôi",
  "阅读更多新闻":"Đọc thêm tin tức",
  "合作伙伴等最新新闻动态":"Tin tức mới nhất về đối tác và hơn thế nữa",
  "AI智能赚币":"Kiếm tiền thông minh AI",
  "出金":"Rút tiền",
  "随存随取":"Gửi tiền và rút tiền bất cứ lúc nào",
  "一键即刻取出,从不等待":"Lấy nó ra ngay lập tức chỉ bằng một cú nhấp chuột, không bao giờ phải chờ đợi",
  "稳定":"Ổn định",
  "最稳健的理财":"Quản lý tài chính ổn định nhất",
  "稳定收益,您的理财助手":"Thu nhập ổn định, trợ lý tài chính của bạn",
  "执行速度":"Tốc độ thực hiện",
  "极速执行":"Thực hiện cực nhanh",
  "所有订单将以毫秒级别速度执行":"Tất cả các lệnh sẽ được thực hiện ở tốc độ mili giây",
  "每天发放":"Phân phối mỗi ngày",
  "当天产生收益":"Lợi nhuận thu được trong ngày",
  "当天购买当天产生收益,24小时及时发放收益":"Tiền thu được sẽ được tạo ra trong cùng ngày mua và sẽ được phân phối nhanh chóng 24 giờ một ngày",
  "现在就开始":"bắt đầu ngay bây giờ",
  "交易全球金融市场":"Giao dịch thị trường tài chính toàn cầu",
  "支持桌面端与移动端多种方式,您可随时 随地开展交易":"Hỗ trợ nhiều phương thức trên máy tính để bàn và thiết bị đầu cuối di động, bạn có thể thực hiện giao dịch mọi lúc, mọi nơi",
  "谷歌下载":"google tải xuống",
  "下载":"tải về",
  "公司":"công ty",
  "关于我们":"về chúng tôi",
  "许可证监督":"Giám sát giấy phép",
  "帮助中心":"Trung tâm trợ giúp",
  "政策":"chính sách",
  "条款与条件":"Điều khoản và Điều kiện",
  "隐私政策":"chính sách bảo mật",
  "声明":"tuyên bố",
  "法律信息":"thông tin pháp luật",
  "免责声明":"Tuyên bố miễn trừ trách nhiệm",
  "风险警告":"Cảnh báo rủi ro",
  "关于广告":"Về quảng cáo",
  "总持仓":"Tổng số vị trí",
  "总收益":"Tổng doanh thu",
  "选择充币币种":"Chọn loại tiền gửi",
  "各币种最小充值数量":"Số tiền gửi tối thiểu của mỗi loại tiền: 1 USDT, 0,001 BTC, 0,1 ETH, 10 TRX Nếu số tiền nhỏ hơn số tiền này, bạn sẽ phải chịu trách nhiệm về việc không thể nhận được chính xác tài khoản của mình.",
  "充币地址":"Địa chỉ gửi tiền",
  "图片上传提示1":"Đặt hình ảnh của bạn ở đây hoặc duyệt qua",
  "图片上传提示2":"Hỗ trợ: JPG, JPEG2000, PNG",
  "搜索币种":"Tìm kiếm tiền tệ",
  "选择提币币种":"Chọn loại tiền rút",
  "最低提币数量":"Số tiền rút tối thiểu: ",
  "小于最低提币数量不能进行提币":"Không thể rút xu nếu số tiền ít hơn số tiền rút tối thiểu",
  "为保障资金安全":"• Để đảm bảo an toàn cho tiền của bạn, khi chính sách bảo mật tài khoản của bạn thay đổi hoặc mật khẩu của bạn bị sửa đổi, chúng tôi sẽ tiến hành xem xét thủ công việc rút tiền. Hãy kiên nhẫn và đợi nhân viên liên hệ với bạn qua điện thoại hoặc email.",
  "请务必确认电脑及浏览器安全":"• Vui lòng đảm bảo máy tính và trình duyệt của bạn được bảo mật để tránh thông tin bị giả mạo hoặc rò rỉ.",
  "您所提的数字资产为一币多链资产":"• Tài sản kỹ thuật số bạn rút là tài sản đa chuỗi một xu, bất kể bạn chọn rút từ chuỗi nào, điều đó có nghĩa là tổng số tài sản kỹ thuật số hiển thị trên trang rút tiền mà bạn sở hữu sẽ giảm đi số tiền rút tương ứng.",
  "提币地址":"Địa chỉ rút xu...",
  currency: {
    bb: 'Trao đổi',
    bba: 'Tài khoản tiền tệ',
    hy: 'Hợp đồng',
    jg: 'quyền chọn',
    jg1: 'Tương lai',
    hya: 'Tài khoản hợp đồng'
  },
  home:{
    user:'Lựa chọn chung của người dùng',
    start:'Bắt đầu giao dịch',
    trading:'Sản phẩm kinh doanh',
    fee:'Phí xử lý tối thiểu',
    co:'có',
    varieties:'Kinh doanh giống',
    leading:'Dẫn đầu sự đổi mới và khám phá web3',
    market:'Xu hướng thị trường sản phẩm kinh doanh',
    explore:'Khám phá những khả năng vô tận',
    newcurrency:'Chức năng đăng ký tiền tệ mới đang trực tuyến!',
    alimited:'Tiền mới đang trực tuyến, bạn có thể mua tiền mới mà bạn cho là có tiềm năng tại đây',
    get_start:'Bắt đầu',
    ai_coin:'Kế hoạch kiếm tiền AI đang được tiến hành',
    ai_text:'Bắt đầu kiếm xu với AI, thu nhập ổn định, tỷ lệ hoàn vốn cao, cho phép bạn kiếm xu ngay khi nằm',
    loan:'Chức năng cho vay trực tuyến',
    loan_text:'Khi không có tiền, bạn có thể đăng ký vay và sẽ được cấp ngay trong ngày',
    mobile_pc:'Được các y tá sử dụng trên PC di động',
    pc_anytime:'Bắt đầu giao dịch mọi lúc, mọi nơi:',
    pc_text:'Chúng tôi cung cấp các công cụ phân tích biểu đồ mạnh mẽ: hơn 50 chỉ báo kỹ thuật và công cụ phân tích đĩa. Đòn bẩy an toàn, đáng tin cậy, dễ sử dụng và các tính năng đòn bẩy cao đã trở thành nền tảng tiêu chuẩn cho đầu tư trực tuyến.',
    mobile_down:'bấm chuột để tải xuống',
    mobile_android:'Chợ Android',
    mobile_ios:'cửa hàng táo',
    open_text:'Bạn có thể đăng ký tài khoản giao dịch thực hoặc dùng thử tài khoản demo miễn phí với một phần ba chi phí.',
    open_account:'một tài khoản',
    tocomplete:'hoàn thành',
    walletlogin:'Đăng nhập ví'
  },
  index: {
    h24: 'Khối lượng 24 giờ',
    header_title: ['Chọn giao dịch tài sản kỹ thuật số ' + window.GLOBAL.LANG_TITLE.zh],
    header_small_title:'Hoàn thành giao dịch tài sản kỹ thuật số blockchain một cửa',
    header_msg: 'An toàn-ổn định-đáng tin cậy',
    register_title: 'Đăng ký một ' + window.GLOBAL.LANG_TITLE.zh + ' tài khoản toàn cầu bắt đầu hành trình giao dịch',
    register_pl: 'Vui lòng nhập email hoặc điện thoại di động của bạn',
    register: 'Đăng ký',
    featureTitleWhy: 'Chọn chúng tôi',
    featureTitle: 'An toàn · ổn định · đáng tin cậy',
    featureMsg: '',
    featureList: [
      {icon: icon1, title: 'Công nghệ Ví an toàn', msg: ['Công nghệ ví nóng và lạnh được phát triển bởi nhóm bảo mật hàng đầu thế giới và chưa bao giờ xảy ra sự cố mất tiền. ',' ']},
       {icon: icon2, title: 'kinh doanh tài sản tiền điện tử phong phú', msg: ['hỗ trợ giao ngay và nhiều giao dịch phái sinh, v.v., là người quản lý cá nhân của bạn trong thế giới tài sản tiền điện tử. ',' ']},
       {icon: icon3, title: 'Khách hàng được phân phối trên toàn thế giới', msg: ['Đối với người dùng ở hơn 130 quốc gia hoặc khu vực trên thế giới, chúng tôi cung cấp đầy đủ các dịch vụ tài sản mã hóa. ',' ']}
    ],
    bannerList: [
      {icon: banner01, title: "Cam kết cung cấp sự ổn định và bảo mật hàng đầu trong ngành", msg: ["hợp đồng thông minh để bảo vệ an toàn tài sản của nhà đầu tư", "hiệu suất giao dịch thực", "đảm bảo dịch vụ 24 giờ"]},
      {icon: banner02, title: "Tôi muốn mua và bán ngay lập tức thông qua các thao tác đơn giản", msg: ["màn hình giao dịch đơn giản", "phản ánh ngay lập tức trong số dư tài khoản của bạn", "hầu hết các loại tiền điện tử có thể được giao dịch"]},
      {icon: banner03, title: "Tôi muốn tích cực kiếm lợi nhuận thông qua giao dịch hợp đồng thanh toán", msg: ["Mở tài khoản cùng lúc", "Đầu tư chiến lược cho một số lượng lớn hợp đồng tương lai", "Bạn có thể giao dịch 24 giờ một ngày, 365 ngày một năm, ngay cả vào cuối tuần "]}
    ],
    featureList2: [
      {icon: icon1_01, title: "Minh bạch và cởi mở", msg: ["Sử dụng các đặc điểm của blockchain và hợp đồng thông minh, nhận ra hiệu suất giao dịch trên chuỗi và sử dụng hợp đồng thông minh để đảm bảo an toàn cho tài sản của nhà đầu tư", ""] },
      {icon: icon1_02, title: "Đầu tư Thông minh", msg: ["Với các chiến lược đa dạng được cung cấp bởi các chuyên gia giao dịch định lượng hàng đầu, bạn có thể tự do lựa chọn", ""]},
      {icon: icon1_03, title: "Phân loại rủi ro", msg: ["Thiết kế các sản phẩm đầu tư đa dạng dựa trên các rủi ro khác nhau và sở thích quản lý tài sản của từng nhà đầu tư, loại bỏ hiệu quả các ngưỡng đầu tư", ""]},
      {icon: icon1_04, title: "Sản phẩm đa dạng", msg: ["Cung cấp nhiều loại nhu cầu đầu tư của người dùng và cơ chế nền tảng linh hoạt, đồng thời tiếp tục sản xuất các dịch vụ tài chính sáng tạo tốt hơn thị trường", ""]}
    ],
    featureTitle2: 'Giao dịch đầu cuối đa nền tảng mọi lúc, mọi nơi',
    featureMsg2: 'Bao gồm nhiều nền tảng iOS và Android, hỗ trợ các chức năng đầy đủ dịch vụ',
    tab: ['Tiền tệ chính', 'Danh sách tăng 24H'],
    thead: ['Cặp giao dịch', 'Giá mới nhất', 'Giá cao nhất trong ngày', 'Giá thấp nhất trong ngày', 'Danh sách tăng', 'Khối lượng 24H', 'Hoạt động'],
    more: 'xem thêm >',
    btn: 'Giao dịch',
    dealsTitle: 'Dịch vụ giao dịch một cửa',
    dealsTab:[
      { title: 'Trao đổi', content: 'Giao dịch tiền tệ là để trao đổi giữa các tài sản kỹ thuật số, sử dụng USDT làm đơn vị định giá để mua các loại tiền tệ khác.'+window.GLOBAL.LANG_TITLE.zh+'Giao dịch tiền tệ hỗ trợ giao dịch thời gian thực của các tài sản kỹ thuật số như Bitcoin, Ethereum và Litecoin.', src:'/static/image/deals-1.jpg', path: '' },
      { title: 'Hợp đồng', content: 'Một phái sinh tài chính của tiền kỹ thuật số không chỉ hỗ trợ lựa chọn mua hợp đồng bán dài hoặc bán ngắn để kiếm thu nhập, mà còn vận hành đơn giản và không bao giờ hết hạn.'+window.GLOBAL.LANG_TITLE.zh+'Hợp đồng có hệ thống quản lý rủi ro tiên tiến với đòn bẩy lên đến 100 lần.', src:'/static/image/deals-2.jpg', path: '' }
    ]
  },
  market: {
    tab: ['Tùy chọn', 'Hợp đồng', 'Đồng xu'],
    thead: ['Tiền tệ', 'Giá mới nhất', 'Thay đổi trong 24 giờ', 'Thấp nhất trong 24 giờ', 'Cao nhất 24 giờ', 'Khối lượng 24 giờ', 'Hoạt động'],
    nodata: 'Không có dữ liệu'
  },
  footer: {
    p: '©Copyright  ' + window.GLOBAL.DEFAULT_YEAR + window.GLOBAL.LANG_TITLE.zh + '. All rights reserved.',
    dd: [
      {
        dt: "Về chúng tôi",
        dd: [{title: "Hồ sơ công ty", id: 1}, {title: "Trung tâm trợ giúp", type: 'help'}]
      },
      {
        dt: "Hỗ trợ người dùng",
        dd: [
          {title: "Thỏa thuận người dùng", id: 3},
          {title: "Chính sách quyền riêng tư", id: 5}
        ]
      },
      {
        dt: "liên hệ chúng tôi",
        icon: true
      }
    ],
    terms: "Các điều khoản và điều kiện",
    serve: "Phục vụ",
    product: "sản phẩm",
  },
  nav: {
    btn: ["Đăng nhập", "Đăng ký", "Quản lý tài sản", "Tải xuống APP"],
    nav: [
      { title: "Trang chủ", path: "/index",name: 'index' },
      // { title: "Trao đổi", path: "/deal",name: 'deal' },
      { title: "Thị trường", path: "/market",name: 'market' },
      { title: "Buôn bán", path: "/preciousMetal", name: 'preciousMetal'},
      // { title: "Trao đổi", path: "/deal", name: 'deal'},
      // { title: "Hợp đồng", path: "/deal_c", name: 'deal_c' },
      // { title: "Tiền điện tử", path: "/deal_jg", name: 'deal_jg' },
      { title: "Tài chính", path: "/profit_index",name: 'profit_index' },
      // { title: "Hoạt động", path: "/sign",name: 'sign' }
    ],
    nav2: [{ title: "Tài sản của tôi", path: "/asset" }],
    menus: [
      {icon: langzh, title: "Trung tâm Người dùng", path: "/setting"},
      {icon: langen, title: "Đăng xuất"}
    ],
    lang: [
      { icon: langen, lang: "English", key: 'en' },
      { icon: langxby, lang: "España", key: 'xby' },
      // { icon: langfy, lang: "français", key: 'fy' },
      // { icon: langdy, lang: "Deutsche", key: 'dy' },
      { icon: langjp, lang: "日本語", key: 'jp' },
      // { icon: langar, lang: "عربي", key: 'ar' },
      { icon: langhy, lang: "한국어", key: 'hy' },
      { icon: langty, lang: "ไทย", key: 'ty' },
      { icon: langyn, lang: "Tiếng Việt", key: 'yn' },
      { icon: langzh, lang: "简体中文", key: 'zh' },
      { icon: langtw, lang: "繁體中文", key: 'ft' },
    ]
  },
  download:{
    "xz": "Tải xuống"
  },
  // 登录
  // login: {
  //   login: 'Vui lòng đăng nhập',
  //   msg: 'Vui lòng nhập tài khoản đã đăng ký của bạn',
  //   list: ['Di động / Email', 'Mật khẩu', 'Quên mật khẩu?', 'Đăng nhập', 'Không có tài khoản, đăng ký ngay'],
  //   message: 'Tài khoản hoặc mật khẩu không được để trống'
  // },
  register: {
    dl: ['Đăng ký di động', 'Đăng ký email'],
    title: 'Đăng ký tài khoản',
    country: 'Quốc tịch',
    country_info: 'Không thể sửa đổi thông tin quốc tịch sau khi đăng ký, vui lòng đảm bảo chọn trung thực',
    account: 'số tài khoản',
    code_text: 'Mã xác minh',
    code_btn: 'Nhận CAPTCHA',
    code_btn1: 'Gửi lại',
    code_unit: 's',
    code_no_data: 'mã xác minh phải được điền',
    password_text: 'Vui lòng nhập mật khẩu của bạn',
    password_again_text: 'Mật khẩu lần nữa',
    pid_text: 'Mã mời',
    pid_pl: 'Không bắt buộc',
    invitation_code_no_data: 'Mã lời mời là bắt buộc',
    xy: 'sự thỏa thuận của người dùng',
    xy_no_checked: 'Vui lòng chọn giao thức',
    agree: 'Tôi đã đọc và đồng ý',
    register_btn: 'Đăng ký',
    bz: ['Không thể sửa đổi thông tin quốc tịch sau khi đăng ký, vui lòng đảm bảo chọn trung thực. ',' Email xác minh có thể bị đánh giá sai là thư rác, vui lòng kiểm tra kỹ. ', 'Hãy giữ của bạn' + window.GLOBAL.LANG_TITLE.zh + 'Số tài khoản và mật khẩu đăng nhập.', 'Không sử dụng cùng mật khẩu đăng nhập với các trang web khác.'],
    account_no_data: 'Tài khoản không được để trống',
    code_no_equality: 'Các mã xác minh không bằng nhau',
    password_no_data: 'mật khẩu không được để trống',
    password_no_equality: 'Hai mật khẩu không bằng nhau'
  },
  // 设置密码
  bindmpwd: {
    title: 'đặt mật khẩu',
    account: 'Số tài khoản',
    code_text: 'Mã xác minh',
    code_btn: 'Nhận CAPTCHA',
    code_unit: 's',
    password_text: 'Vui lòng nhập mật khẩu của bạn',
    password_again_text: 'Mật khẩu lần nữa',
    code_no_data: 'mã xác minh phải được điền',
    code_no_equality: 'Các mã xác minh không bằng nhau',
    password_no_data: 'mật khẩu không được để trống',
    password_no_equality: 'Hai mật khẩu không bằng nhau',
    bindmpwd_btn: 'Xác nhận',
    phone_no_data: 'Số điện thoại không được để trống',
    password_login_text: 'Vui lòng nhập mật khẩu đăng nhập',
    password_trade_text: 'Mật khẩu gồm 6 chữ số',
    password_again_tarde_text: 'Mật khẩu gồm 6 chữ số',
  },
  // 忘记密码
  forgetpwd: {
    title: ['Sửa đổi mật khẩu', 'Quên mật khẩu'],
    account: '账号',
    code_text: 'Mã xác minh',
    code_btn: 'Nhận CAPTCHA',
    code_unit: 's',
    password_text: 'Vui lòng nhập mật khẩu của bạn',
    password_again_text: 'Mật khẩu lần nữa',

    phone_no_data: 'Số điện thoại không được để trống',

    account_no_data: 'Tài khoản không được để trống',
    code_no_data: 'mã xác minh phải được điền',
    code_no_equality: 'Các mã xác minh không bằng nhau',
    password_no_data: 'mật khẩu không được để trống',
    password_no_equality: 'Hai mật khẩu không bằng nhau',
    forgetpwd_btn: 'Xác nhận'
  },
  // 绑定手机号码
  bindphone: {
    title: 'Ràng buộc số điện thoại di động',
    phone_text: 'số điện thoại',
  },
  person: {
    more: 'Tải thêm',
    no_more: 'Không có thêm dữ liệu',
    index_center:"Trung tâm người dùng",
    index_menus: [
      { icon: zhsz, title: "Quản lý tài khoản", path: '/setting' },
      { icon: sfrz, title: "Xác thực KYC", path: '/sfyz' },
      { icon: sfrz, title: "Chứng chỉ sơ cấp", path: '/smauth' },
      { icon: sfrz, title: "Đã xác minh", path: '/seniorauth' },
      { icon: jtrz, title: "Xác thực địa chỉ", path: '/dzrz' },
      { icon: jtrz, title: "Mua Tiền mật mã", path: '/kjmbSelect' },
      { icon: jtrz, title: "Điểm tín dụng", path: '/credit' },
      { icon: jtrz, title: "Hồ sơ", path: '/deallog' },
      { icon: jtrz, title: "Hồ sơ tiền ký quỹ", path: '/cbjl' },
      { icon: jtrz, title: "Hồ sơ rút tiền", path: '/tbjl' },
    ],
    cbtb: 'Ký quỹ & Rút tiền',
    jymx: 'Chi tiết giao dịch',
    xyf: {
      'title': 'Điểm tín dụng',
      'pgsj': 'Thời gian đánh giá'
    },
    smrz:{
       title:'Đã xác minh' ,
       sure_title: 'Bạn đã vượt qua xác thực tên thật',
       zj_type: 'Loại chứng chỉ',
       zj_info: ['1, không thể sửa đổi thông tin chứng nhận sau khi đã xác minh, vui lòng điền trung thực', '2, thông tin tên thật đã xác minh không thể được chứng nhận lại'],
       zj_name: 'Tên',
       zj_num: 'số tài liệu',
       zj_btn: 'Được',
       zj_rebtn: 'Xác minh lại',
       zj_sebtn: 'Xác minh nâng cao',
       zj_type_array:[{name:'Thẻ ID',type:'idcard'}],
       idCardArr: [
        {
            id: 1,
            name: "Thẻ ID"
        },
        {
            id: 2,
            name: "Hộ chiếu"
        },
        {
            id: 3,
            name: "Bằng lái xe"
        },
        {
            id: 4,
            name: "giấy phép thường trú"
        },
        {
            id: 5,
            name: "khác"
        }
       ],
       zj_data:{city:'Quốc tịch không được để trống',type:'Loại thông tin xác thực không được để trống',name:'Không được để trống tên',zj_num:'Không được để trống số ID'},
       zsxm: 'Tên thật',
       qsrzsxm: 'Vui lòng nhập tên thật của bạn',
       zjlx: 'Loại ID hợp lệ',
       qxzzjlx: 'Vui lòng chọn loại ID',
       sfz: 'Thẻ ID',
       zjhm: 'Số ID',
       qsrzjhm: 'Vui lòng nhập số ID',
       sczjz: 'Tải lên ảnh ID',
       zjzm: 'Tải lên ảnh mặt trước của tài liệu ID',
       zjfm: 'Tải lên ảnh mặt sau của tài liệu ID',
       qsczjzm: 'Vui lòng tải lên ảnh mặt trước của giấy tờ tùy thân của bạn',
       qsczjfm: 'Vui lòng tải lên ảnh mặt sau giấy tờ tùy thân của bạn',
       scqmz: 'Tải lên các tài liệu ID và chữ ký cá nhân',
       qscscqmz: 'Vui lòng tải lên ID và ảnh chữ ký cá nhân của bạn',
       zj: [
         {
           id: 1,
           title: 'Thẻ ID'
         },
         {
           id: 2,
           title: 'Hộ chiếu'
         },
         {
           id: 3,
           title: 'khác'
         },
       ],
       tj: 'Gửi',
       shz: 'Đang xem xét',
       shtg: 'Đã phê duyệt'
    },
    gjrz:{
      title:'Chứng chỉ cao cấp',
      zj_info:['1. Hỗ trợ các ảnh dưới 8MB và định dạng JPG, JPEG hoặc PNG.','2. Các ảnh tài liệu ID phải rõ ràng và sẽ không bị chỉnh sửa hoặc che khuất. Mã số tài liệu ảnh cá nhân và tên của chủ sở hữu tài liệu phải dễ nhìn.','3. Các ảnh phải được chụp mà không có bất kỳ vật che đầu nào và không khuyến khích trang điểm khi chup. Các đường nét khuôn mặt trong ảnh phải rõ ràng và dễ nhận biết và không để lộ toàn bộ tay.'],
      zj_img:['/static/image/User_Center_Front_view.png','/static/image/User_Center_Back_Shot.png','/static/image/User_Center_Full_picture.png'],

    },
    zhgl:{
      title:'Cài đặt hệ thống bảo vệ',
      bind:[{bind_title: 'Đặt lại mật khẩu', bind_name: 'Email'}, {bind_title: 'Đặt mật khẩu giao dịch', bind_name: 'Email'}]
    },
    wdtg:{
      own_code: 'Mã lời mời độc quyền',
      own_code_url: 'Kết nối lời mời độc quyền',
      own_push_title: 'Quảng cáo của tôi',
      own_push_content: ['Tổng doanh thu từ lời mời (định giá)', 'số lượng lời mời', 'số người'],
      own_push_content_profit: ['Quyền lợi lời mời cấp độ 1', 'Quyền lợi lời mời cấp độ 2', 'Quyền lợi lời mời cấp độ 3', 'Quyền lợi lời mời cấp độ 4'],
      own_push_content_num: ['Số lượng lời mời ở cấp độ đầu tiên', "Số lượng lời mời ở cấp độ thứ hai", "Số lượng lời mời ở cấp độ thứ ba", "Số lượng lời mời ở cấp độ thứ tư"],
      own_push_profit_title: ['ID', 'lợi nhuận', 'thông tin nhận xét', 'thêm thời gian'],
      own_push_num_title: ['ID', 'name', 'phone', 'add time'],
    },
    jyzt_td: ['Thời gian', 'chi tiết', 'lượng'],
    cbjl_td: ['Thời gian', 'tiền tệ', 'số lượng', 'trạng thái'],
    sfrz_txt: ['Xác thực danh tính', 'Bạn đã gửi kiểm tra, vui lòng đợi kết quả', 'Bạn đã vượt qua xác thực nâng cao', 'Mặt trước của thẻ ID', 'Mặt sau của thẻ ID', 'Xác thực', ' Xác thực không thành công, vui lòng xác thực lại '],

    zhsz_txt: ['Cấp độ bảo mật tài khoản của bạn: #', 'Cấp độ bảo mật tài khoản của bạn: #, cải thiện thêm thông tin và đảm bảo bảo mật tài khoản'],
    zhsz_m: 'mạnh',
    zhsz_n: 'yếu',
    zhsz_p: 'không an toàn',
    zhsz_detailList: [
      { icon: '/static/image/User_Center-password.png', title: 'Mật khẩu đăng nhập', value: 'Tài khoản Internet có nguy cơ bị đánh cắp. Bạn nên thay đổi mật khẩu thường xuyên để bảo vệ an toàn cho tài khoản của mình. ', value2:'', btn:'biến đổi', bind_email:' trước tiên hãy liên kết email hoặc điện thoại di động', path: '/forgetpwd?type=changepwd' },
      { icon: '/static/image/User_Center-password.png', title: 'Mật khẩu giao dịch', value: 'Đặt mật khẩu', btn: 'Chuyển đến thiết lập', path: '/bindmpwd' }
    ],
    sksz_txt: ['Cài đặt Biên nhận', 'Lưu'],
    sksz_list: [
      { label: "用户名:", pl: "请输入用户名", key: "name" },
      { label: "开户行名称:", pl: "请输入开户行名称", key: "bank_name" },
      { label: "银行卡号:", pl: "请输入银行卡号", key: "bank_number" },
      { label: "支付宝账号:", pl: "请输入支付宝账号", key: "alipay_account" },
      { label: "微信昵称：", pl: "请输入微信昵称", key: "weixin_nickname" },
      { label: "微信账号：", pl: "请输入微信账号", key: "weixin_account" }
    ]
  },
  pasination: {
    first: 'Trang chủ',
    prev: 'Trang trước',
    next: 'Trang tiếp theo',
    last: 'Trang Cuối cùng',
    no_data: 'Không có dữ liệu',
  },
  asset: {
    title: 'Tài sản của tôi',
    zjhz: 'Chuyển quĩ',
    cb: 'Tiền ký quỹ',
    gz: 'Định giá USDT',
    atnv: [],
    zh_title: 'Tổng tài sản quy đổi：',
    index_title: 'tài sản',
    address_title: 'Tiền tệ',
    address_txt: ['xin vui lòng chọn', 'Địa chỉ rút tiền', 'Vui lòng nhập nội dung', 'nhận xét', 'danh sách địa chỉ'],
    address_btn: ['Thêm', 'Lưu', 'Xóa', 'Chỉnh sửa'],
    address_td: ['Tiền tệ', 'Địa chỉ rút tiền', 'Chú thích', 'Vận hành'],
    currency_td: ['Tiền tệ', 'Khả dụng', 'Đóng băng', 'Chuyển đổi'],

    table_title: 'Tổng tài sản：',
    table_address_title: 'Quản lý địa chỉ rút tiền',
    table_td: ['Tiền tệ', 'Khả dụng', 'Đóng băng', 'Chuyển đổi', 'Vận hành'],
    table_btn: ['Tiền ký quỹ', 'Rút tiền', 'ghi âm', 'chuyển khoản'],

    money_text: ['Địa chỉ rút tiền', 'xin vui lòng chọn', 'Số lượng', 'Khả dụng：', 'Phí',
      'Số tiền đến', 'Mật khẩu giao dịch','Thẻ (Ghi nhớ)','Tối thiểu '],
    money_btn: 'Rút tiền',
    xzbz: 'Lựa chọn tiền tệ',
    money_msg: ['Lời nhắc', '1. Thời gian rút tiền là 12: 00-24: 00 giờ Hồng Kông, với 2 đơn rút tiền mỗi ngày (rút tối thiểu 100u, rút ​​tối đa 200.000u);', '2. Hiện tại, rút ​​tiền chỉ được hỗ trợ bằng tiền USDT, Loại liên kết ví chọn ERC20; ',' 3. Sau khi gửi đơn xin rút tiền, tiền sẽ bị đóng băng do quá trình rút tiền đang diễn ra và tiền tạm thời được quản lý bởi hệ thống và bạn không thể tự do kiểm soát. Nó không có nghĩa là bạn đã mất tài sản hoặc tài sản bất thường. Vui lòng kiên nhẫn chờ phê duyệt; ',' 4. Thời gian đến sau khi gửi đơn rút tiền tùy thuộc vào thời gian xác nhận của khối. Nếu không dự kiến ​​rút tiền sau thời gian rút tiền, vui lòng liên hệ với bộ phận chăm sóc khách hàng để được giải đáp; ',' 5. Để ngăn chặn Thiết lập hành vi hiện tại, 90% tổng số tiền tiêu dùng được yêu cầu để bắt đầu rút tiền '],

    recharge_title: 'Địa chỉ nạp tiền',
    recharge_btn: ['Sao chép', 'Mã QR', 'Tiền ký quỹ'],
    recharge_text: ['Số lượng', 'Lời nhắc', 'Không nạp tiền cho bất kỳ tài sản không phải USDT nào vào địa chỉ trên, nếu không tài sản sẽ không được truy xuất. ',' Tiền gửi USDT chỉ hỗ trợ phương thức gửi đơn giản, tiền gửi sử dụng các phương thức khác (gửi tất cả) tạm thời không thể được đăng, xin vui lòng hiểu. ','Thông tin đăng nhập', 'diễn tả(Không bắt buộc)','Tên chuỗi'],

    record_title: 'Các báo cáo tài chính',
    record_td: ['Số lượng', 'ghi âm', 'Thời gian'],

    transfer_title: 'chuyển khoản',
    transfer_btn: ['Tất cả', 'chuyển giao'],
    transfer_text: ['Từ', 'đến', 'Vui lòng nhập số tiền chuyển', 'Khả dụng：'],
    "bq": "Thẻ (Ghi nhớ)",
    "qsrbq": "Vui lòng nhập thẻ",
    "yhktx": "Rút qua thẻ ngân hàng",
    "yhmc": "Tên ngân hàng",
    "qsryhmc": "Vui lòng nhập tên ngân hàng",
    "yhzh": "Tài khoản ngân hàng",
    "qsryhzh": "Vui lòng nhập số tài khoản ngân hàng",
    "gjhkdm": "Mã SWIFT",
    "qsrgjhkdm": "Vui lòng nhập mã SWIFT",
    "yhdz": "Địa chỉ ngân hàng",
    "qsryhdz": "Vui lòng nhập địa chỉ ngân hàng",
    "skrxm": "Tên người hưởng",
    "qsrskrxm": "Vui lòng nhập tên người hưởng",
    "skrdh": "Số điện thoại của người hưởng",
    "qsrskrdh": "Vui lòng nhập số điện thoại của người hưởng",
    "skrdz": "Địa chỉ của người hưởng",
    "qsrskrdz": "Vui lòng nhập địa chỉ của người hưởng"
  },
  text: {
    btn: 'return',
    login: 'Vui lòng đăng nhập trước'
  },
  deal: {
    chooseType: 'Loại hoa hồng',
    choose: 'xin vui lòng chọn',
    balance: 'Số dư：',
    account: ['Tài khoản', 'Có sẵn', '/ Đóng băng', 'Chuyển khoản'],
    dir: ['Mua', 'Bán'],
    dir2: ['Có sẵn', 'Có thể mua bán'],
    cs: 'Tùy chọn',
    sxf: 'Tỷ lệ phí',
    jye: 'Số tiền giao dịch',
    sc_list: ['Thị trường', 'cặp tiền', 'giá tăng'],
    sc_h: ['Latest', '24H Lowest', '24H Highest', '24H Vol.'],
    td_lt: ['tiền tệ', 'giá mới nhất', 'giá đã tăng'],
    k_line_txt: ['≈', '', 'Tăng', 'Giá cao nhất', 'Giá thấp nhất', 'Khối lượng 24 giờ'],
    tabListLTitle: ["Lệnh mở", "Hoa hồng lịch sử"],
    tabListLEntrust: ["Mua", "Bán"],
    tabListRTitle: ["Hạn chế giao dịch", "Giao dịch thị trường"],
    table_btn: ['Hủy lệnh'],
    index_td_l: ['Thời gian', 'Đối tượng giao dịch', 'Số lượng', 'Giá', 'Hoạt động'],
    index_td_r: ['Giá mới nhất', 'hướng đi', 'Giá', 'số lượng'],
    index_td_r2: ['Giao dịch mới nhất', 'Thời gian', 'Giá', 'Khối lượng giao dịch'],
    table_txt: ['Đã hoàn tất', 'Đã hủy lệnh'],

    db_1_txt: ["Có sẵn", "Giá mua", "Giá bán", "Khối lượng mua", "Khối lượng bán", "Khối lượng giao dịch", "Mua với giá tốt nhất thị trường", "Giá tốt nhất thị trường để bán ",' mua tay ',' bán tay '],
    db_2_txt: ['Giá', 'đòn bẩy', 'vui lòng chọn', 'lô', 'một lô bằng', 'lô', 'giá trị thị trường hợp đồng', 'ký quỹ', 'mua với giá thị trường tốt nhất', ' tại thị trường Bán giá tốt nhất '],
    pathList: ['Bản ghi hợp đồng', 'Bản ghi giao dịch'],
    db_btn: ['Mua (mua lâu dài)', 'Bán (bán khống)'],
    tabListLTitle2: ['Lệnh mở'],

    lt_btn: ['Thanh khoản một lần nhấp chuột', 'Đặt mức dừng lãi và giá cắt lỗ', 'Đóng', 'Xác nhận ngay bây giờ', 'trở về'],
    lt_txt: ['Tỷ lệ rủi ro:', 'Tổng lãi và lỗ của vị thế:'],
    lt_td: ['Loại', 'Đòn bẩy nhiều', 'Giá vị thế', 'Giá hiện tại', 'Ký quỹ', 'Giá chốt lời', 'Giá cắt lỗ', 'Thời gian mở', 'Số lô', ' Lãi và lỗ ',' Hoạt động '],
    lt_dl: ['Set the Stop Loss and price cắt lỗ', 'Chốt lời', 'Giá cắt lỗ'],

    lt_0_btn: ['Hủy lệnh'],
    lt_0_td: ['Thông tin liên hệ', 'Đơn vị tiền tệ', 'Số lượng', 'Giá hiện tại', 'Phí xử lý', 'Vận hành'],

    lt_1_btn: ['Đóng'],
    lt_1_txt: ['Đang đóng'],
    lt_1_td: ['Loại', 'Giá vị thế', 'Giá hiện tại', 'Ký quỹ', 'Giá chốt lời', 'Giá cắt lỗ', 'Thời gian mở cửa', 'Phí xử lý', 'Lãi lỗ', 'Hoạt động'],
    node_data: 'Không có dữ liệu',

    lt_3_txt: ['Đã đóng', 'Thanh toán'],
    lt_3_td: ['Loại', 'Lô', 'Giá vị thế', 'Giá đóng cửa', 'Giá chốt lời', 'Giá cắt lỗ', 'Ký quỹ', 'Ký quỹ khả dụng', 'Thời gian mở cửa', 'Thời gian đóng cửa', ' Phí xử lý ','Lãi và lỗ', 'hoạt động'],

    lt_4_txt: ['Đã hủy lệnh'],
    cm: ['Thời gian công bố', 'Mã số phát hành', '流通总量', '总凑价格', 'Trang web chính thức','Sách trắng','介绍'],
    qsrsl: 'Vui lòng nhập số tiền',
    qsrss: 'Vui lòng nhập lô',
  },
  notice:{
      notice_title:'Trung tâm thông báo',
  },
  bzhl:{
    title: 'AI kiếm tiền',
    title1: 'Định lượng AI',
    ttzbt: '天天赚不停',
    wdtg: 'Lưu trữ của tôi',
    zztgdzj: 'Quỹ giám hộ',
    yjjrsy: 'Ước tính hàng ngày',
    ljsy: 'Tổng doanh thu',
    tgzdd: 'Lệnh giám hộ',
    tgdd: 'Lệnh ký quỹ',
    t1: 'Rủi ro thấp và quản lý tài chính ổn định, có thể đổi trả bất kỳ lúc nào nếu cần',
    t2: 'Trợ lý quản lý tiền miễn phí của bạn',
    cljxcp: 'Chu kỳ sản phẩm',
    dbxe: 'Hạn mức đơn',
    rsyl: 'Lợi suất hàng ngày(%)',
    rsyl2: 'Lợi suất hàng ngày：',
    zq: 'Chu kỳ',
    qmr: 'Đi mua',
    ckgd: '더보기',
    cpgk: 'Tổng quan về sản phẩm',
    pxsj: 'Thời gian thanh toán cổ tức',
    tgzj: 'Vốn chủ sở hữu giám hộ',
    tqsh: 'Sự chuộc lỗi sớm',
    cpld: 'Những điểm nổi bật của sản phẩm',
    cpgz: 'Quy tắc sản phẩm',
    cont: 'Di chuyển gạch là bằng cách lưu trữ USDT trên nền tảng và đội ngũ chuyên nghiệp của nền tảng có quyền di chuyển gạch. Người tham gia có thể nhận được phần thu nhập từ chuyển gạch của nền tảng trong thời gian lưu ký quỹ. Có thể truy cập vào bất kỳ lúc nào. là an toàn và thuận tiện.',
    zj: 'Tài trợ 100%',
    aqbz: 'Bảo mật',
    jjrsy: 'Thu nhập vào ngày nghỉ lễ',
    bjd: 'Không gián đoạn',
    cgcrh: 'Sau khi ký quỹ thành công',
    dtqx: 'Giá trị lãi suất theo ngày',
    ljzr: 'Chuyển ngay',
    xqglgj: 'Các công cụ quản lý tiền miễn phí',
    ddh: 'Mã số lệnh',
    tgje: 'Số tiền giám hộ',
    tgsj: 'Chu kỳ ngày',
    yhl: 'Đã có lãi',
    xdsj: 'Thời gian đặt lệnh',
    zt: 'trạng thái',
    fh: 'trở về',
    qrnhsy: '七日年化收益',
    ygy: '1个月',
    bn: '半年',
    yn: '1年',
    yuan: '元',
    tzfx: 'rủi ro đầu tư',
    shsc: 'Thời gian đổi thưởng',
    di: 'Thấp',
    yggzr: 'Một ngày làm việc',
    msgsxf: 'Phí đăng ký miễn phí',
    mr: 'Hàng ngày',
    dqfh: 'Hoàn trả khi đến hạn',
    ljgm: 'Mua ngay',
    tgz: 'Giám hộ',
    sh: 'Đổi',
    ywc: 'Đã hoàn tất',
    ysh: 'Đã đổi',
    all: 'Tất cả',
    "xzbzts": "Đơn giản và an toàn. Cổ tức có thể được chọn bằng nhiều loại tiền tệ",
    "qtbz": "Các loại tiền khác"
  },
  pay:{
    qsrjymm: 'Vui lòng nhập mật khẩu giao dịch gồm 6 chữ số',
    tbmmts: 'Vui lòng đến trung tâm người dùng để đặt mật khẩu giao dịch',
  },
  tips:{
    qxztbdz: 'Vui lòng nhập địa chỉ rút tiền',
    qsrtbsl: 'Vui lòng nhập số lượng của tiền tệ sẽ rút'
  },
  statusText: ['Không thành công', 'Đang chờ xử lý', 'Thành công'],
  dzrz: {
    title: 'Xác thực địa chỉ',
    sdddz: 'Địa chỉ hóa đơn tiện ích',
    zdtpsc: 'Tải lên ảnh hóa đơn',
    qsrsdddz: 'Bạn cần điền thông tin địa chỉ và gửi hóa đơn điện nước hoặc hóa đơn địa chỉ băng thông rộng',
    qsczdtp: 'Vui lòng tải lên hình ảnh của hóa đơn',
    status: ['đang xem xét', 'đánh giá đã thông qua'],
    qd: 'Được',
  },
  jgcc: {
    wtgd: 'Lệnh đang chờ',
    cj: 'Thỏa thuận',
    jj: 'Thông tin',
    zc: 'Hiện thời',
    lszc: 'Lịch sử',
    qblx: 'Tất cả các loại',
    xj: 'Giá hiện thời',
    sj: 'Thời gian',
    fx: 'Xu hướng',
    jg: 'Giá',
    sl: 'Số lượng',
    jgsj: 'Thời gian giao',
    gmj: 'Giá mua',
    jsj: 'Giá thanh toán',
    yk: 'Lãi và lỗ',
    xq: 'Chi tiết',
    "mz": "Tăng giá",
    "md": "Giảm giá",
    dqye: 'Số dư hiện thời',
    gb: 'Đóng',
    jxxd: 'Tiếp tục đặt lệnh',
    qrxd: 'Xác nhận',
    ddqr: 'Xác nhận lệnh',
    sxf: 'Phí',
    kyye: 'Thăng bằng',
    jypz: 'Cặp',
    jyfx: 'Xu hướng',
    tzje: 'Số tiền đầu tư',
    tzjeTips: 'Số tiền đầu tư không được bằng 0',
    dqsj: 'Thời gian hết hạn',
    jssj: 'Thời gian giao',
    gmsj: 'Thời gian mua hàng',
    sy: 'Lãi',
    zxje: 'Số tiền tối thiểu ',
    shi: 'H',
    fen: 'M',
    miao: 's',
    zdje: 'Số tiền tối đa ',
    qsrje: 'Vui lòng nhập số tiền',
    zxtzje: 'Tối thiểu ',
    yebz: 'Thiếu cân bằng',
    xq: 'Chi tiết',
    ddz: 'Đang chờ đợi',
    jgjl: 'Biên bản giao hàng',
    bz: 'Tiền tệ',
    cz: 'Vận hành'
  },
  kjmb: {
    title: 'Mua Tiền mật mã',
    fzcg: 'Sao chép thành công',
    ljmb: 'Mua Tiền mật mã',
    lxkf: 'liên hệ với dịch vụ khách hàng'
  },
  news: {
    title: 'Tin nhắn của tôi',
    "gg": "Thông báo",
    ckxq: 'Xem chi tiết'
  },
  statusTabs:['Danh sách hàng chờ', 'Đang giao dịch','Đã đóng', 'Đã rút'],
  "chongzhi":{
    "zy": "Quan trọng",
    "cbxx": "Thông tin tiền gửi mã thông báo",
    "qsrsl": "Vui lòng nhập số tiền gửi",
    "tips2": "1. Khả năng tương thích của ví / nền tảng: nghĩa là mạng được hỗ trợ; nếu nền tảng đích không hỗ trợ mạng rút tiền của bạn, thì không thể truy xuất tài sản.",
    "tips3": "2. Mạng nạp tiền của bạn và nền tảng mục tiêu giống nhau; nếu bạn chọn địa chỉ mục tiêu là mạng Ethereum, nhưng người nạp tiền chọn chuỗi thông minh TRC20, bạn có thể không truy xuất được tài sản kỹ thuật số của mình.",
    "tips4": "3. Đảm bảo rằng địa chỉ và số tiền của bạn là chính xác trước khi nạp tiền.",
    "tips5": "Nhắc nhở: Do tính ẩn danh và tính riêng tư của mạng khối, một khi bạn nhập sai thông tin, bạn sẽ mất tài sản tương ứng. Vui lòng kiểm tra kỹ địa chỉ và số lượng nạp tiền của bạn",
    "tips2_1": "• Vui lòng không tính phí bất kỳ tài sản không phải nội tệ nào cho địa chỉ trên, nếu không, không thể truy xuất tài sản.",
    "tips2_2": "• Không thể giao tiền kỹ thuật số đúng lúc. Thời gian đến thực tế phụ thuộc vào tốc độ xác nhận của blockchain.",
    "tips2_3": "• Địa chỉ nạp tiền của bạn sẽ không thay đổi thường xuyên, bạn có thể nạp tiền; nếu có bất kỳ thay đổi nào, chúng tôi sẽ cố gắng hết sức để thông báo cho bạn qua email hoặc thông báo trên trang web.",
  },
  "tibi": {
    "tbxx": "Thông tin Rút tiền",
    "qsrbq": "Vui lòng nhập nhãn",
    "tbTips1": "• Để đảm bảo an toàn cho nguồn tiền, khi chính sách bảo mật tài khoản của bạn thay đổi, thay đổi mật khẩu, chúng tôi sẽ xem xét thủ công việc rút tiền, hãy kiên nhẫn chờ nhân viên liên hệ với bạn qua điện thoại hoặc email.",
    "tbTips2": "• Hãy đảm bảo rằng máy tính và trình duyệt của bạn an toàn để ngăn thông tin bị giả mạo hoặc bị rò rỉ.",
    "tbTips3": "• Tài sản kỹ thuật số mà bạn đề cập là tài sản đa chuỗi một xu. Bất kể bạn chọn huy động từ chuỗi nào, điều đó có nghĩa là tổng số tài sản kỹ thuật số hiển thị trên trang rút tiền mà bạn sở hữu sẽ bị giảm bằng số tiền tương ứng đã huy động được. ",
  },
  "gjlb": "Danh sách các quốc gia",
  "qxzgjlb": "Vui lòng chọn Quốc gia / Vùng",
  "mbwt":{
    "title": "Vấn đề An ninh",
    "mbwt": "Vấn đề An ninh",
    "problem":[
      {
        "id": 1,
        "title": "Ai là người bạn thân nhất của bạn?"
      },
      {
        "id": 2,
        "title": "Thần tượng của bạn là ai?"
      },
      {
        "id": 3,
        "title": "Nơi khao khát nhất của bạn là ở đâu?"
      }
    ],
    "qtxda": "Vui lòng trả lời",
    "qsrxmm": "Vui lòng nhập mật khẩu mới",
    "qqrmm": "Vui lòng xác nhận mật khẩu của bạn",
    "sydqmmcz": "Sử dụng Đặt lại Mật khẩu Hiện tại",
    "zhmm": "Vấn đề bảo mật Lấy lại mật khẩu",
    "ysz": "Cài đặt",
    "tg": "Bỏ qua",
    "tj": "Gửi đi",
    "zyts": "Quan trọng:",
    "zytsCont": "Không tiết lộ câu trả lời bí mật và mã xác minh, đồng thời lưu ý vấn đề bảo mật, điều này sẽ giúp bạn lấy lại mật khẩu của mình"
  },
  "zc":{
    "zclb": "Danh sách tài sản",
    "zczh": "Chuyển đổi tài sản",
    "yczc": "Ẩn tài sản bạn không có"
  },
  "indexNew":{
    "t1": "Hàng đầu Toàn cầu",
    "t2": "Nền tảng Dịch vụ Tài sản Kỹ thuật số",
    "t3": "Hoàn thành giao dịch tài sản kỹ thuật số blockchain một cửa",
    "t4": "Số điện thoại di động / Email",
    "t5": "Đăng ký ngay",
    "t6": "Chào mừng khách hàng từ khắp nơi trên thế giới thông qua MFTG",
    "t7": "Khám phá và bắt đầu hành trình mã hóa của chúng"
  },
  "newReg":{
    "dl": ['e-mail','Di động'],
    "cjzh": "Tạo tài khoản",
    "sysjhzyx": "Đăng ký bằng số điện thoại di động / email",
    "yhxy": "&lt;Thoản thuận người dung&gt;",
    "yhxy2": "Tôi đã đọc và đồng ý với &lt;Thoản thuận người dung&gt;",
    "yxgz": "Vui lòng nhập email hợp lệ",
    "dhgz": "Số điện thoại di động không chính xác"
  },
  "indexNew2": {
    "t1": "Giao dịch theo lệnh của chúng tôi",
    "t2": "Sử dụng Bitbank",
    "t3": "Bitbank là một sàn giao dịch trao đổi bitcoin và tài sản mã hóa được thiết kế khéo léo. Nó rất đơn giản, thuận tiện, an toàn và mạnh mẽ. Nó hỗ trợ giao dịch trên nhiều nền tảng web và điện thoại thông minh. Dữ liệu và biểu đồ giao dịch được cập nhật theo thời gian thực. Toàn diện phân tích giá thị trường cung cấp hơn 60 công cụ phân tích kỹ thuật. Hãy bắt đầu giao dịch ",
    "ksjy": "Bắt đầu giao dịch",
    "ly": "5 lý do để chọn Bitbank",
    "item1_t1": "Khối lượng giao dịch hàng đầu",
    "item1_t2": "Khối lượng giao dịch tài sản tiền điện tử số 1 *",
    "item1_t3": "Tính thanh khoản cao, giao dịch thoải mái (trải nghiệm giao dịch dễ chịu). Liệt kê 12 loại tài sản tiền điện tử.",
    "item2_t1": "Đánh giá cao của bên thứ ba",
    "item2_t2": "Môi trường giao dịch an toàn",
    "item2_t3": "Sử dụng ví lạnh ngoại tuyến. Sử dụng Multisig để ngăn chặn tin tặc. Bảo vệ tài sản của bạn bằng công nghệ cao",
    "item3_t1": "Ứng dụng dễ sử dụng và đáng tin cậy",
    "item3_t2": "Ứng dụng dễ sử dụng và đơn giản",
    "item3_t3": "Một ứng dụng đáng tin cậy với các chức năng phong phú. Nó có thể duy trì các cơ hội giao dịch bên ngoài giao dịch.",
    "item4_t1": "Mở cửa cả ngày",
    "item4_t2": "Có thể gửi vàng",
    "item4_t3": "Hỗ trợ tiền gửi 24 giờ, kể cả ngày lễ!",
    "item5_t1": "Điện thoại thông minh và PC",
    "item5_t2": "Thiết kế nhân bản",
    "item5_t3": "Ngay cả khi bạn sử dụng điện thoại thông minh, bạn có thể thực hiện các giao dịch đơn giản và đủ điều kiện mà không do dự",
    "aqkk": "An toàn và đáng tin cậy",
    "aqkk2": "Giao dịch Bitcoin Bitbank",
    "cjzh": "Tạo tài khoản",
  },
  "xbsg":{
    "title": "Khu vực tiền xu mới",
    "wdsg": "Thông tin chi tiết",
    "scts": "Ngày nhốt: ",
    "sy": "còn lại",
    "ljsg": "Theo dõi ngay",
    "ysk": "Bán hết",
    "xzjdy": "Theo dõi ngay",
    "dy": "Đặt mua",
    "fxjg": "giá phát hành",
    "fxl": "Vòng tuần hoàn",
    "ssrq": "Ngày niêm yết",
    "yxqx": "Thời gian hiệu lực",
    "qsrsl": "Vui lòng nhập số tiền",
    "syl": "còn lại",
    "sgrq": "đặt mua",
    "sgsl": "Số lượng",
    "bz": "Đồng tiền",
    "yebz": "Số dư USDT không đủ",
    "tgsl": "Vượt qua Qty",
    "shz": "đang xem xét",
    "wtg": "Không vượt qua",
    "ytg": "thông qua"
  },
  "wydb":{
    "title": "Vay",
    "db": "Vay",
    "dbz": "Vay",
    "jl": "ghi lại",
    "jdzq": "vay (ngày)",
    "qhk": "Trả lại",
    "ljdb": "Tích lũy (usdt)",
    "dhkbs" :"Trong khi chờ thanh toán",
    "jkje": "số tiền (usdt)",
    "qsrje": "Vui lòng nhập số tiền",
    "rll": "Lãi suất hàng ngày",
    "hkfs": "Trả nợ",
    "dqych": "Hết hạn",
    "lx": "Quan tâm",
    "fkjg": "Người cho vay",
    "tpsc": "Khoản vay tín dụng (tải lên hình ảnh)",
    "fwxx": "Thông tin nhà ở",
    "srzm": "Chứng minh thu nhập (mối quan hệ việc làm)",
    "yhmx": "Sao kê ngân hàng",
    "zjz": "Ảnh ID",
    "yd": "Tôi đã đọc và đồng ý",
    "xy": "Đăng ký hợp đồng vay",
    "sqdb": "đăng ký chuỗi cho vay",
    "gb": "Khép kín",
    "qd": "VÂNG",
    "ts": "Vui lòng kiểm tra Đăng ký hợp đồng vay",
    "dbjl": "ghi lại",
    "hkhth": "Mã đặt hàng",
    "wsh": "Chưa được đánh giá",
    "yfk": "Tiền vay",
    "sqrq": "thời gian nộp đơn",
    "zq": "xe đạp",
    "dbsl": "số lượng",
    "zhke": "Tổng tiền thanh toán",
    "yhkxq": "Chi tiết trả nợ",
    "bqyhk": "Phải trả trong kỳ hiện tại(USDT)",
    "hktips": "Hãy đảm bảo số dư còn đủ, nếu số dư không đủ vui lòng nạp tiền trước rồi hoàn trả",
    "bj": "Hiệu trưởng",
    "jie": "Vay",
    "ljhk": "Trả nợ ngay lập tức",
    "qcz": "Gửi tiền",
    "yebzqxcz": "Không đủ số dư, vui lòng nạp tiền trước và sau đó hoàn trả",
    "znj": "phí thanh toán chậm",
    "yqts": "Ngày quá hạn"
  },
  "hkxq":{
    "dd":"Gọi món",
    "fzhkdz":"Sao chép địa chỉ trả nợ",
    "hkxq": "Chi tiết trả nợ",
    "zlx": "tổng lãi",
    "zhk": "tổng số tiền hoàn trả",
    "hkjg": "cơ quan trả nợ",
    "qschkpz": "Vui lòng tải lên chứng chỉ hoàn trả",
    "hkpz": "giấy chứng nhận trả nợ"
  },
  "bbjyNew":{
    "jylx": "Các loại",
    "jyze": "Số lượng"
  },
  "bind":{
    "title": "email",
    "ybd": "Ràng buộc",
    "wbd": "Không ràng buộc",
    "ts": "Để bảo vệ tài khoản của bạn, bạn nên liên kết một địa chỉ email",
    "qsryxdz": "Vui lòng nhập địa chỉ email của bạn"
  },
  "tipsNew": {
    "yjj": "từ chối",
    "shz": "chuộc lỗi"
  },
  "newIndex2": {
    "zxhy": "Báo giá Mới nhất",
    "jypt": "Nền tảng giao dịch",
    "ssyc": "Thu hẹp Ẩn",
    "hwzc": "Bạn chưa đăng ký?",
    "ljzc": "Đăng ký ngay bây giờ và khám phá rất nhiều cơ hội!",
    "yyzh": "Đã có tài khoản?",
    "hjbj": "Đăng nhập nếu bạn có tài khoản, lâu rồi không gặp!",
    "lmdh": "Điều hướng Cột",
    "ghdjy": "Thỏa thuận tốt hơn, cuộc sống tốt hơn",
    "ghdjy02": "Trung tâm giao dịch tiền điện tử sáng tạo nhất thế giới ở đây, nơi bạn có thể mua, giao dịch và kiếm tiền điện tử với hàng trăm loại tiền điện tử trong tầm tay của bạn.",
    "indexCont01": "Luôn bên cạnh bạn",
    "indexCont02": "Giao dịch thị trường giao ngay và thị trường ký quỹ của chúng tôi với các tùy chọn cấp vốn nâng cao, khớp lệnh nhanh như chớp và thanh khoản sâu.",
    "indexCont03": "API mạnh mẽ",
    "indexCont04": "Dễ dàng quản lý các vị trí của bạn với API trực quan, nền tảng giao dịch và các tùy chọn đặt hàng nâng cao của chúng tôi.",
    "indexCont05": "Nội dung kỹ thuật số chất lượng cao",
    "indexCont06": "9 năm 0 tai nạn",
    "indexCont07": "Kiểm soát Rủi ro Bảo mật Hàng đầu",
    "indexCont08": "Đòn bẩy lên đến 25 lần",
    "indexCont09": "Giao dịch CFD Bitcoin với đòn bẩy gấp 25 lần.",
    "indexCont010": "Dự trữ an toàn",
    "indexCont011": "Thanh khoản sâu",
    "indexCont012": "Công nghệ đặt hàng đa thị trường độc quyền tiên tiến của chúng tôi giúp tăng cường tính thanh khoản, thắt chặt chênh lệch và giảm trượt giá.",
    "indexCont013": "Sở thích người dùng",
    "indexCont014": "Quốc gia được Bảo hiểm",
    "indexCont015": "Điểm mạnh của chúng tôi",
    "indexCont016": "Giao dịch thị trường giao ngay và thị trường ký quỹ của chúng tôi với các tùy chọn cấp vốn nâng cao, khớp lệnh nhanh như chớp và thanh khoản sâu.",
    "indexCont017": "Lưu trữ An toàn",
    "indexCont018": "Chúng tôi sử dụng kết hợp ví lạnh và công nghệ tính toán đa bên (MPC) để quản lý tài sản kỹ thuật số.",
    "indexCont019": "An toàn trên hết",
    "indexCont020": "Chúng tôi sử dụng công nghệ mới nhất để giữ an toàn cho tiền của bạn và luôn vượt qua các lỗi và các nỗ lực khai thác.",
    "indexCont021": "Rút tiền nhanh",
    "indexCont022": "Sử dụng tính toán của nhiều bên, chúng tôi có thể cung cấp dịch vụ rút tiền nhanh 24/7 trong khi vẫn duy trì các tiêu chuẩn bảo mật nghiêm ngặt của chúng tôi.",
    "indexCont023": "Mua, Bán tiền điện tử",
    "indexCont024": "Tham gia nền tảng giao dịch an toàn và toàn diện nhất thế giới",
    "indexCont025": "Mua và bán Bitcoin, Ethereum, XRP và nhiều loại tiền điện tử khác bằng fiat hoặc tiền điện tử.",
    "yqwj": "10 triệu +",
    "dlzc": "Đăng nhập để đăng ký",
    "yzm": "Mã xác minh",
    "qrmm": "Xác nhận mật khẩu"
  },
  "langNew2":{
    "flzq": "Trung tâm phần thưởng",
    "qdjl": "Đăng nhập phần thưởng",
    "mrqdjl": "Phần thưởng đăng nhập hàng ngày",
    "qd": "Đăng nhập",
    "yqd": "Đăng nhập",
    "hdgz": "Thể lệ sự kiện",
    "qdjl2": "Nhật ký nhập cảnh",
    "qdcg": "Đăng nhập thành công",
    "yhd": "Đã nhận được",
    "lq": "Nhận",
    "dyt": "Ngày 1",
    "det": "Ngày 2",
    "dst": "Ngày 3",
    "dsit": "Ngày 4",
    "dwt": "Ngày 5",
    "dlt": "Ngày 6",
    "dqt": "Ngày 7",
    "jxz": "đang tiến hành",
    "cjxnzh": "Tạo một tài khoản demo",
    "sy":"Trang chủ",
    "sc":"Chợ",
    "sclb":"Danh sách thị trường",
    "jy":"Buôn bán",
    "zh":"Tài khoản",
    "db":"Khoản vay",
    "zchm":"Số đăng ký",
    "cp":"Sản phẩm",
    "tzjd":"Cho vay đầu tư",
    "zxzc":"Hỗ trợ trực tuyến",
    "xd":"Đặt hàng",
    "zzjptgmnr":"Đầu tư vào tương lai của bạn. Phát triển danh mục đầu tư của bạn trong một hệ thống tài chính công bằng và cởi mở.",
    "yy":"Ứng dụng",
    "pqnr":"Ngân hàng di động phá vỡ các quy tắc truyền thống và cung cấp cho bạn các công cụ quản lý tài chính chính xác.",
    "jiami":"Tiền điện tử",
    "tgnr":"Bằng cách gửi tiền bằng tiền điện tử, bạn có thêm một lớp bảo mật và đảm bảo xử lý giao dịch nhanh chóng.",
    "jyl":"Khối lượng giao dịch 24h",
    "ssjmhb":"Danh sách tiền điện tử",
    "zchy":"Người dùng đã đăng ký",
    "djxz":"Bấm chuột để tải xuống",
    "azsc":"Chợ Android",
    "pgsd":"Cửa hàng táo",
    "bqxx":'©Copyright  ' + window.GLOBAL.DEFAULT_YEAR + window.GLOBAL.LANG_TITLE.zh + '. All rights reserved.',
  },
  // "langNew":{
  //   "szhb": "tiền điện tử",
  //   "gjs": "Kim loại",
  //   "yy": "thô",
  //   "jy": "Buôn bán",
  //   "jmhb": "tiền điện tử",
  //   "yxhy": "Hợp đồng vĩnh viễn",
  //   "gdjy": "danh sách hàng chờ",
  //   "khh": "Tài khoản đang mở",
  //   "qsrkhh": "Vui lòng nhập ngân hàng",
  //   "yhkh": "Tài khoản ngân hàng",
  //   "qsryhkh": "Vui lòng nhập số tài khoản ngân hàng",
  //  },
   "login":{
     login: 'Vui lòng đăng nhập',
     msg: 'Vui lòng nhập tài khoản đã đăng ký của bạn',
     list: ['Di động / Email', 'Mật khẩu', 'Quên mật khẩu?', 'Đăng nhập', 'Không có tài khoản, đăng ký ngay'],
     message: 'Tài khoản hoặc mật khẩu không được để trống',
     "cdlks":"Hãy bắt đầu với việc đăng nhập!",
     "zh":"Tài khoản",
     "qsrzh":"Nhập tên người dùng của bạn",
     "mm":"Mật khẩu",
     "qsrmm":"Nhập mật khẩu",
     "dl":"Đăng nhập",
     "wjmm":"Quên mật khẩu",
     "qbdl":"Đăng nhập bằng Ví",
     "myzh":"Tôi không có tài khoản?",
     "zc":"Đăng ký",
     "yzm":"Mã xác nhận",
     "qsryzm":"Nhập mã xác nhận",
     "hqyzm":"Mã đã gửi",
     "qrmm":"Xác nhận mật khẩu",
     "qsrqrmm":"Xác nhận mật khẩu",
     "lcmmbyz":"Hai lần nhập mật khẩu không nhất quán",
     "mmts":"Độ dài mật khẩu 6-12 ký tự",
     "sjtx":"Lỗi định dạng số điện thoại",
     "yxts":"Lỗi định dạng email",
     "qr":"ĐƯỢC RỒI",
     "sjzc":"Điện thoại di động",
     "sjh":"Số điện thoại",
     "qsrsjh":"Nhập số điện thoại",
     "yqm":"Mã lời mời (tùy chọn)",
     "qsryqm":"Nhập mã mời",
     "yxzc":"E-mail",
     "wyydbzx":"Đồng ý",
     "yhxy":"<Thỏa thuận dịch vụ người dùng>",
     "yhxy2":"Thỏa thuận dịch vụ người dùng",
     "ysyx":"<Thỏa thuận bảo vệ quyền riêng tư>",
     "yx":"E-mail",
     "qsryx":"Nhập email",
     "yxgsbzc":"Email không hợp lệ",
     "cjmnzhcg":"Tài khoản demo được tạo thành công",
     "tcmnzh":"Thoát khỏi tài khoản demo",
     "qbdlts":"Vui lòng sử dụng ví DAPP Đăng nhập",
   },
   // "index":{
   //   "xgnysx":"Các tính năng mới đang trực tuyến!",
   //   "hyld":"Chào mừng bạn đến với nền tảng giao dịch tài chính từng đoạt giải thưởng của chúng tôi và khám phá thế giới tài chính tương lai với các nhà đầu tư toàn cầu",
   //   "symncz":"Sử dụng tài khoản demo",
   //   "zdjyfy":"Phí giao dịch tối thiểu <0,3%",
   //   "jysyzc":"Giao dịch tất cả tài sản của bạn ở một nơi",
   //   "hbsp":"Forex, Tiền điện tử, Cổ phiếu, Chỉ số, Hàng hóa",
   //   "ksjy":"Bắt đầu",
   //   "jdewd":"Đơn giản và ổn định",
   //   "aizb":"Giao dịch AI vàng",
   //   "srjh":"Tạo kế hoạch thu nhập của bạn chỉ bằng một cú nhấp chuột",
   //   "kssy":"Bắt đầu sử dụng",
   //   "dlyhggdje":"Lãi suất thấp và số tiền cao hơn",
   //   "jmhbdk":"Cho vay tiền điện tử",
   //   "zmyrhdyp":"Vay tiền điện tử giao ngay mà không cần bất kỳ tài sản thế chấp nào",
   //   "gs":"Công ty",
   //   "gywm":"Về chúng tôi",
   //   "xkzjd":"Giám sát giấy phép",
   //   "bzzx":"Trung tâm trợ giúp",
   //   "zhengce":"Chính sách",
   //   "tkytj":"Các điều khoản và điều kiện",
   //   "yszc":"Chính sách bảo mật",
   //   "sm":"Tuyên bố",
   //   "flxx":"Thông tin hợp pháp",
   //   "mzsm":"Tuyên bố miễn trừ trách nhiệm",
   //   "fxjg":"Cảnh báo rủi ro",
   //   "gygg":"Về quảng cáo",
   //   "gg":"Thông báo",
   // },
   "hq":{
     "wh":"Ngoại hối",
     "szhb":"tiền điện tử",
     "gp":"Cổ phần",
     "zs":"Mục lục",
     "eft":"ETF",
     "mc":"Tên",
     "xs":"24h%",
     "tb":"Đồ thị",
     "jg":"Giá",
   },
   "user":{
     "wdzh":"Tài khoản của tôi",
     "zh":"Tài khoản: ",
     "dk":"Khoản vay: ",
     "sydbzj":"Ký quỹ được sử dụng: ",
     "yqll":"Lợi nhuận kì vọng: ",
     "qtgn":"Cac chưc năng khac",
     "cz":"Tiền gửi",
     "tx":"Rút",
     "dh":"Trao đổi",
     "zhyz":"Chứng nhận KYC",
     "zhjl":"Hồ sơ tài khoản",
     "yqhy":"Mời bạn bè",
     "flzq":"Khu phúc lợi",
     "ggmm":"Đổi mật khẩu",
     "sz":"Cài đặt",
     "cjwtjd":"Câu hỏi thường gặp",
     "fzdz":"Sao chép địa chỉ",
     "sl":"Số lượng...",
     "qsrsl":"Nhập số lượng",
     "dd":"Nhận (USDT): ",
     "sczm":"Tải chứng từ lên",
     "qsczm":"Vui lòng tải lên chứng từ",
     "tj":"Nộp",
     "czjl":"Hồ sơ gửi tiền",
     "ddh":"KHÔNG.",
     "wsh":"Chưa được xem xét",
     "ywc":"Hoàn thành",
     "bz":"Tên: ",
     "sl2":"Số lượng: ",
     "sj":"Thời gian: ",
     "srsl":"Nhập số lượng...",
     "dd2":"Lấy: ",
     "qskgzflhd":"Hãy luôn chú ý đến các hoạt động phúc lợi, chúng tôi sẽ phát hành chúng theo thời gian",
     "hdlb":"Danh sách sự kiện",
     "ckxq":"Xem chi tiết",
     "wdjl":"Phần thưởng của tôi",
     "yiji":"Cấp độ 1",
     "erji":"Cấp độ 2",
     "sanji":"Cấp 3",
     "je":"Số lượng",
     "sj2":"Thời gian",
     "yyxz":"Ngôn ngữ",
     "tcdl":"Đăng xuất",
     "je2":"Số tiền (USD)...",
     "qsrje":"Nhập số tiền",
     "jsdz":"Địa chỉ nhận...",
     "qsrjsdz":"Nhập địa chỉ nhận",
     "sjdz":"Đến thực tế: ",
     "sxf":"Phí: ",
     "txsm1":"Việc rút tiền yêu cầu phí 5%, phí này cần được nút mạng xác nhận trước khi có thể ghi có",
     "txsm2":"Vui lòng không chuyển tiền điện tử cho người lạ",
     "tz":"Thông báo",
     "wdyq":"Lời mời của tôi",
     "yhid":"UID",
     "hdjl":"Nhận phần thưởng USD",
     "yqsm":"Mời bạn bè của bạn tham gia định lượng Ai, thuê máy khai thác và giao dịch sản phẩm để nhận phần thưởng tiền điện tử",
     "yqsy":"Thu nhập từ lời mời",
     "yqrs":"Số người được mời",
     "tgljyq":"Mời qua liên kết",
     "lj":"liên kết",
     "yqm":"Mã mời",
     "cbtb":"Gửi và rút tiền",
     "jymx":"Chi tiết giao dịch",
     "yqhyjl":"Phần thưởng khi mời bạn bè",
     "aidd":"Lệnh giao dịch AI vàng",
     "jdls":"Lịch sử khoản vay",
     "etfdd":"Lệnh ETF",
     "jmhbdd":"Đơn đặt hàng tiền điện tử",
     "whdd":"Lệnh ngoại hối",
     "gpdd":"Lệnh chứng khoán",
     "qx":"Hủy bỏ",
     "zc":"Tài sản",
     "zzc":"Tổng tài sản",
     "ky":"Có sẵn",
     "zh2":"Đã chuyển đổi (USDT)",
     "xzbz":"Lựa chọn: ",
     "sztkts":"Quan trọng: Vui lòng vào Trung tâm bảo mật để đặt mật khẩu giao dịch",
     "jymm":"Mật khẩu giao dịch",
     "szjymm":"Đặt mật khẩu giao dịch",
     "qsrjymm":"Mật khẩu giao dịch",
     "zdsl":"Số lượng tối thiểu.",
     "bq":"Thẻ(Bản ghi nhớ)",
     "qsrbq":"Nhập thẻ",
     "yhktx":"chuyển khoản ngân hàng",
     "yhmc":"tên ngân hàng",
     "qsryhmc":"Nhập tên ngân hàng",
     "yhzh":"Tài khoản ngân hàng",
     "qsryhzh":"Nhập số tài khoản ngân hàng",
     "gjhkdm":"Mã SWIFT",
     "qsrgjhkdm":"Nhập mã SWIFT",
     "yhdz":"địa chỉ ngân hàng",
     "qsryhdz":"Nhập địa chỉ ngân hàng",
     "skrxm":"Tên người nhận",
     "qsrskrxm":"Nhập tên người nhận thanh toán",
     "skrdh":"Số điện thoại người nhận thanh toán",
     "qsrskrdh":"Nhập số điện thoại của người nhận thanh toán",
     "skrdz":"Địa chỉ người nhận thanh toán",
     "qsrskrdz":"Nhập địa chỉ người nhận thanh toán",
     "tbjl":"Hồ sơ rút tiền",
     "fzcg":"Đã sao chép thành công",
     "aqzx":"Trung tâm bảo vệ",
     "yxrz":"xác thực email",
     "ybd":"ràng buộc",
     "wbd":"Không giới hạn",
     "yrz":"Đã xác minh",
     "wrz":"Không công nhận, không chứng nhận",
     "ts":"Để bảo vệ tài khoản của bạn, bạn nên liên kết địa chỉ email của mình",
     "qsryxdz":"Nhập email",
     "dlmm":"Mật khẩu đăng nhập",
     "mbwtsz":"Cài đặt vấn đề bảo mật",
     "mbwt":"Vấn đề an ninh",
     "qtxda":"Hãy điền câu trả lời",
     "zyts":"Quan trọng: ",
     "zytsCont":"Vui lòng không tiết lộ câu trả lời bảo mật và mã xác minh, đồng thời ghi nhớ câu hỏi bảo mật, điều này sẽ giúp bạn khôi phục mật khẩu của mình.",
     "qsrxmm":"Nhập mật khẩu mới",
     "sydqmmcz":"Đặt lại bằng mật khẩu hiện tại",
     "zhmm":"Vấn đề bảo mật để lấy lại mật khẩu",
     "ysz":"Đã được chuẩn bị",
     "tg":"phớt lờ",
     "qsrdlmm":"Nhập mật khẩu của bạn",
     "bzxz":"Lựa chọn: ",
     "zwsj":"Không có dữ liệu",
     "qd":"ĐƯỢC RỒI",
     "zsgd":"Cho xem nhiều hơn",
     "zdss":"Kích thước lô tối thiểu",
     "mnjy":"tài khoản demo",
     "sx":"Lọc",
   },
   "zb":{
     "tgdd":"Đơn đặt hàng được quản lý bằng AI",
     "tgz":"Bị giam giữ",
     "ysh":"Đã chuộc",
     "shz":"Trong sự chuộc lại",
     "zq":"Xe đạp: ",
     "tian":"Ngày",
     "syl2":"Tỷ lệ lợi nhuận: ",
     "rgjg":"Giá thuê bao: ",
     "rgjg2":"Giá thuê bao",
     "xdsj":"Thời gian phục vụ: ",
     "yhl":"Có lợi nhuận: ",
     "syts":"Số ngày còn lại: ",
     "sh":"chuộc lỗi",
     "syl":"Tỷ lệ lợi nhuận",
     "bz":"Tên",
     "dl":"Tỷ giá",
     "tgts":"Ngày tổ chức: ",
     "tgsl":"Số lượng hosting",
     "qsrtgsl":"Nhập số lượng hosting",
     "dbxe":"Hạn mức giao dịch duy nhất",
     "ljtg":"Lưu trữ ngay bây giờ",
     "zztg":"Tiền đang bị tạm giữ",
     "yjjrsy":"Thu nhập ước tính ngày hôm nay",
     "ljsy":"Thu nhập tích lũy",
     "tgzdd":"Ra lệnh tạm giữ",
     "ljzc":"Chuyển ngay",
     "gz":"Luật lệ",
     "cpzq":"Chu kỳ sản phẩm",
     "gm":"Mua",
     "ts":"Quan trọng",
     "shts":"Bạn đang trong quá trình thực hiện quy đổi và bạn sẽ mất 5% nếu quy đổi trước hạn. Bạn có chắc chắn đổi quà không?",
     "xgcs":"Giới hạn số lần mua",
   },
   "dk":{
     "dk":"Khoản vay",
     "dkzh":"Tài khoản cho vay",
     "yzsf":"Xác minh danh tính của bạn và nhận thêm số tiền cho vay!",
     "ksyz":"Bắt đầu xác minh",
     "wxj":"Tôi muốn mượn...",
     "dkqx":"Thời hạn vay (ngày): ",
     "mrll":"Lãi suất hàng ngày: ",
     "lxze":"Tổng tiền lãi: ",
     "dkts":"Khoản vay không bị tính lãi trong 3 ngày và lãi có thể được trả sau đó",
     "xzj":"Vay ngay bây giờ",
     "wyydbzx":"Đồng ý",
     "dkfwxy":"<Thỏa thuận dịch vụ cho vay>",
     "dkfwxy2":"Thỏa thuận dịch vụ cho vay",
     "dkysxy":"Thỏa thuận bảo mật khoản vay",
     "dkjl":"Lịch sử khoản vay",
     "hth":"KHÔNG.",
     "yfk":"Đã giải ngân",
     "lx":"Quan tâm: ",
     "zhke":"Tổng số tiền hoàn trả: ",
     "znj":"Phí thanh toán chậm: ",
     "znjl":"Mức phí trễ hạn: ",
     "yqts":"Số ngày quá hạn: ",
     "qhk":"Hoàn lại",
     "tpsc":"Vay tín dụng (tải lên hình ảnh)",
     "fwxx":"Thông tin nhà ở",
     "srzm":"Bằng chứng về thu nhập (mối quan hệ việc làm)",
     "yhmx":"thông tin chi tiết ngân hàng",
     "zjz":"ảnh giấy tờ tùy thân",
     "ljdk":"Vay ngay bây giờ",
     "xm":"Tên",
     "ndxm":"Tên của bạn",
     "qsrndxm":"Nhập tên của bạn",
     "gj":"Quốc gia",
     "ndgj":"Quốc gia của bạn",
     "qsrndgj":"Nhập quốc gia của bạn",
     "dz":"Địa chỉ",
     "nddz":"Địa chỉ của bạn",
     "qsrnddz":"Nhập địa chỉ của bạn",
     "csrq":"Ngày sinh",
     "ndcsrq":"Ngày sinh của bạn",
     "qsrndcsrq":"Nhập ngày sinh của bạn",
     "dhhm":"Số điện thoại",
     "nddhhm":"Số điện thoại của bạn",
     "qsrnddhhm":"Nhập số điện thoại của bạn",
     "zj":"Các tài liệu",
     "sfzm":"Bản sắc tích cực",
     "qscsfzm":"Tải lên mặt tích cực của danh tính của bạn",
     "sffm":"Ngược lại với danh tính",
     "qscsffm":"Tải lên mặt sau danh tính của bạn",
     "ddqr":"Xác nhận đơn hàng",
     "jk":"Khoản vay: ",
     "dkqx2":"Thời hạn cho vay: ",
     "qrxd":"Xác nhận đơn hàng",
     "yhkxq":"Chi tiết số tiền phải trả",
     "hkqr":"Xác nhận hoàn trả",
     "yhk":"Đến hạn trả nợ: ",
     "jksj":"Thời gian vay: ",
     "ljhk":"Trả hết ngay lập tức",
   },
   "jy":{
     "rq":"ngày",
     "qqjy":"Bản ghi tùy chọn",
     "hyjy":"Hợp đồng",
     "qqhy":"Tùy chọn",
     "dqwt":"Chưa giải quyết",
     'wtz':"Trong ủy quyền",
     "hyjl":"Hồ sơ hợp đồng",
     "shou":"Rất nhiều",
     "dk":"Ồ: ",
     "zhjg":"Muộn nhất: ",
     "jyfy":"Phí giao dịch: ",
     "kfsj":"Giờ mở cửa: ",
     "gg":"Đòn bẩy: ",
     "pl":"Lô hàng: ",
     "kpj":"Giá mở cửa: ",
     "yk":"Lợi nhuận và thua lỗ: ",
     "cd":"Hủy đơn hàng",
     "jsj":"Giá thanh toán: ",
     "fx":"Phương hướng: ",
     "jgsj":"Thời gian giao hàng: ",
     "gb":"Đóng",
     "jxxd":"Tiếp tục",
     "xj":"Giới hạn: ",
     "gm":"Mua: ",
     "sl":"Số lượng",
     "fy":"Trị giá: ",
     "tzbzj":"Điều chỉnh lề",
     "zyzs":"Chốt lãi và dừng lỗ",
     "pc":"Đóng vị thế",
     "mr":"Mua",
     "zjbzj":"Tăng ký quỹ",
     "jsbzj":"Giảm ký quỹ",
     "yxhy":"giao dịch hợp đồng: ",
     "cc":"(Các) vị trí: ",
     "cc2":"Chức vụ",
     "cwbzk":"Ký quỹ vị thế: ",
     "zdzjbzj":"Mức tăng ký quỹ tối đa: ",
     "zjbzj2":"Tăng ký quỹ: ",
     "qsrzbzj":"Vui lòng nhập số tiền đặt cọc",
     "yxhy2":"vĩnh viễn",
     "kp":"Có thể bằng phẳng",
     "zhang":"Mở",
     "xj2":"Giới hạn",
     "zy":"chốt lời",
     "zs":"Chặn đứng tổn thất",
     "ssjyzl":"Tìm kiếm loại giao dịch",
     "ddb":"Quyển sổ đặc Mua hàng",
     "di":"L: ",
     "gao":"H: ",
     "gb2":"C: ",
     "fz":"Phút",
     "mai":"Mua: ",
     "zhang2":"Tăng lên",
     "tie":"Ngã",
     "sy":"Trở lại",
     "kz":"Tăng giá",
     "kt":"Giảm giá",
     "bndy":"Không thể thấp hơn",
     "sxbzj":"Tiền đặt cọc bắt buộc: ",
     "ky":"Có sẵn: ",
     "sj":"Chợ",
     "mc":"Bán",
     "zxtzsl":"Số lượng tối thiểu",
     "min":"Số tiền tối thiểu",
     "max":"Số tiền lớn nhất",
     "yebz":"Thiếu cân bằng",
     "ddz":"Chờ",
     "wtzl":"Số tiền hoa hồng: ",
     "wtjg":"Giá hoa hồng: ",
     "ycd":"Đã hủy",
     "lswt":"lịch sử",
     "qsrzyjg":"Vui lòng nhập giá chốt lời",
     "qsrzsjg":"Vui lòng nhập giá dừng lỗ",
     "ccsl":"Số lượng vị trí: ",
     "ccjg":"Giá vị trí: ",
     "ggbs":"Tận dụng nhiều: ",
     "zy2":"Lấy lợi nhuận: ",
     "zs2":"Chặn đứng tổn thất: ",
     "zje":"Số tiền trả một lần: ",
     "ss":"Rất nhiều: ",
     "kcjg":"Giá mở cửa: ",
     "bzjl":"Tỷ lệ ký quỹ: ",
     "lscc":"Vị trí lịch sử",
     "gmj":"Giá mua: ",
     "guadan":"Danh sách hàng chờ",
     "dqjg":"Giá hiện tại: ",
     "gdjg":"Giá lệnh chờ: ",
     "pcjg":"Giá đóng cửa: ",
     "ccsj":"Thời gian nắm giữ vị thế: ",
     "gdsj":"Thời gian chờ xử lý lệnh: ",
     "pcsj":"Thời gian đóng cửa: ",
     "fdjyk":"Lãi lỗ ròng thả nổi",
     "pcsl":"Số lượng đóng",
     "qrpc":"Xác nhận đóng vị thế",
     "ypc":"Vị thế đã đóng",
     "ss2":"Rất nhiều",
     "qsrss":"Nhập kích thước lô",
   },
   "gjrz":{
     "sfyz":"Chứng nhận KYC",
     "t1":"1. Hỗ trợ hình ảnh định dạng JPG, JPEG hoặc PNG nhỏ hơn 8M.",
     "t2":"2. Ảnh CMND phải rõ ràng và không được phép sửa đổi hoặc chặn. Chân dung, số CMND và tên phải được nhìn thấy rõ ràng.",
     "t3":"3. Ảnh phải được chụp không đội mũ và không nên trang điểm. Nét mặt của người cầm tài liệu phải được nhìn thấy rõ ràng và toàn bộ cánh tay phải lộ ra ngoài.",
     "t4":"ĐƯỢC RỒI",
     "bh":"Từ chối",
     "shz":"Đổi thưởng",
     "shtg":"Kỳ thi đã qua",
     "nyrzcg":"Bạn đã được xác thực thành công",
     "sczjz":"Tải ảnh CMND lên",
     "sczjzmz":"Tải lên ảnh mặt trước của giấy tờ tùy thân của bạn",
     "sczjbmz":"Tải lên ảnh mặt sau CMND của bạn",
     "scgrqmz":"Tải lên ảnh chụp CMND của bạn trên tay",
     "gjlb":"Danh sách quốc gia",
     "qxzgjlb":"Chọn quốc gia/khu vực",
     "zsxm":"Tên thật",
     "qsrzsxm":"Nhập tên thật của bạn",
     "zjlx":"Loại chứng chỉ: ",
     "zjhm":"số ID",
     "qsrzjhm":"Nhập số ID của bạn",
     "khh":"Ngân hàng mở tài khoản",
     "qsrkhh":"Nhập ngân hàng mở tài khoản",
     "yhkh":"Số thẻ ngân hàng",
     "qsryhkh":"Nhập số thẻ ngân hàng",
   },
   "status":{
     "statusText":['Không thành công','Đang xem xét','Thành công'],
   },
   "download":{
     "t1":"Giao dịch di động, mọi lúc, mọi nơi",
     "xz":"Tải xuống",
   },
   "langNew":{
     "cxsqsh": "Đăng ký lại để đổi",
     "jxtg": "Tiếp tục lưu trữ",
     "szhb": "tiền điện tử",
     "gjs": "Kim loại",
     "ny": "Năng lượng",
     "yy": "thô",
     "jy": "Buôn bán",
     "jmhb": "tiền điện tử",
     "yxhy": "Hợp đồng vĩnh viễn",
     "gdjy": "danh sách hàng chờ",
     "khh": "Tài khoản đang mở",
     "qsrkhh": "Vui lòng nhập ngân hàng",
     "yhkh": "Tài khoản ngân hàng",
     "qsryhkh": "Vui lòng nhập số tài khoản ngân hàng",
     "mnzh":"tài khoản demo",
     "zjjypt":"Nền tảng giao dịch tốt nhất",
     "brjmzndxq":"Phần mềm này đáp ứng mọi nhu cầu của bạn với chuyên môn kỹ thuật tốt nhất",
     "jx":"Tiếp tục",
     "yssm":"Cam kết bảo mật",
     "fxqzc":"Chính sách chống rửa tiền",
     "jgxkz":"Giấy phép quy định",
     "ckgd":"Hơn",
     "gd":"Hơn",
     "dd":"Đặt hàng",
     "ckdd":"Xem đơn đặt hàng",
     "yxdd":"vĩnh viễn",
     "qqdd":"Tùy chọn",
     "hand":"Tôi rất nhiều= ",
     "lxwm":"Liên hệ chúng tôi",
     "tpfzl":"Đặt hình ảnh của bạn ở đây hoặc ",
     "liulang":"duyệt qua",
     "zctpgs":"Hỗ trợ: JPG, JPEG2000, PNG",
     "ysr":"Thu nhập hàng tháng",
     "ndysr":"Thu nhập hàng tháng của bạn",
     "qsrndysr":"Nhập thu nhập hàng tháng của bạn",
     "yqtzje":"Số tiền đầu tư dự kiến",
     "qsrtzje":"Nhập số tiền đầu tư dự kiến",
     "zszh":"Tài khoản thực",
     "qdl":"Làm ơn đăng nhập",
     "zx": "Yêu thích",
     "hkdz":"Địa chỉ trả nợ",
     "dkje":"Số tiền vay: ",
     "zlx":"Tổng lãi: ",
     "hkze":"Tổng số tiền hoàn trả: ",
     "qcz":"Đi để nạp tiền",
     "yebz":"Số dư của bạn không đủ, vui lòng nạp tiền",
     "dhje":"Số tiền phải hoàn trả：",
     "hkjl":"Lịch sử trả nợ：",
     "hkje":"Số dư khả dụng：",
     "kyye":"Số tiền trả nợ：",
     "qb": 'Tất cả',
     "lmc": "Tên chuỗi：",
     "search": "Tìm kiếm",
     "mrjg":"Giá",
     "lxkf":"kết nối",
     "wyj":"thiệt hại thanh lý",
     "yxsj":"trong tiến trình：",
     "jssj":"Hoàn thành：",
     "hksj":"Trả nợ：",
     "sysj":"Thời gian còn lại：",
     "jkqx":"Thời hạn cho vay：",
     "yq":"Quá hạn：",
     "qqss":"Lệnh giao dịch quyền chọn của bạn đã hết hạn và khoản lỗ của bạn là ",
     "qqlr":"Lệnh giao dịch quyền chọn của bạn đã hết hạn và lợi nhuận của bạn là",
     "bz":"Tiền tệ",
     "dzje":"Số tiền nhận được",
     "lxyxzc":"Hỗ trợ qua email",

     "mnzh": "Tài khoản Demo",
         "zszh": "Tài khoản thực",
         "qsrgjc": "Vui lòng nhập từ khóa",
         "wh": "Ngoại hối",
         "szhb": "Tiền kỹ thuật số",
         "js": "Kim loại",
         "ny": "Năng lượng",
         "sj": "giá thị trường",
         "gd": "Lệnh chờ",
         "mr": "Mua",
         "mc": "Bán",
         "ss": "Kích thước Lô",
         "qsrss": "Vui lòng nhập kích thước lô",
         "zy": "Chốt lời",
         "zs": "Cắt lỗ",
         "qsrzyj": "Vui lòng nhập giá chốt lãi",
         "qsrzsj": "Vui lòng nhập giá cắt lỗ",
         "xfbzj": "Yêu cầu ký quỹ:",
         "kyye": "Số dư khả dụng:",
         "cc": "Vị trí",
         "ypc": "Vị thế đã đóng",
         "name": "tên",
         "ddh": "Số Đơn Hàng",
         "mmfx": "Hướng mua và bán",
         "gmfs": "Phương thức mua hàng",
         "xdj": "Giá đặt hàng",
         "sxf": "Phí dịch vụ",
         "sxf2": "Phí xử lý:",
         "cz": "Hoạt động",
         "pc": "Đóng vị trí",
         "cx": "Hoàn tác",
         "pccg": "Đóng cửa thành công",
         "dl": "Đăng nhập",
         "yxhzhdl": "Email và tài khoản đăng nhập",
         "qsryxhzh": "Vui lòng nhập địa chỉ email hoặc tài khoản của bạn",
         "mm": "Mật khẩu",
         "qsrmm": "Vui lòng nhập mật khẩu",
         "cjxnzh": "Tạo một tài khoản demo",
         "wjmm": "Has olvidado tu contraseña",
         "myzh": "Không có tài khoản?",
         "zc": "Đăng ký",
         "wjmm2": "Quên mật khẩu",
         "zh": "Tài khoản",
         "qsrzh": "Vui lòng nhập số tài khoản",
         "yzm": "Mã xác nhận",
         "qsryzm": "Vui lòng nhập mã xác minh",
         "hqyzm": "Nhận mã xác minh",
         "qrmm": "Xác nhận mật khẩu",
         "qzcsrmm": "Vui lòng nhập lại mật khẩu",
         "qd": "Được",
         "yxh": "Số hộp thư",
         "qsryxh": "Vui lòng nhập số hộp thư của bạn",
         "sjh": "Số điện thoại di động",
         "qsrsjh": "Vui lòng nhập số điện thoại của bạn",
         "xm": "Tên",
         "qsrxm": "Vui lòng nhập tên của bạn",
         "gj": "Quốc tịch",
         "qxzgj": "Vui lòng chọn quốc tịch",
         "zjlx": "Loại chứng chỉ",
         "qxzzjlx": "Vui lòng chọn loại tài liệu",
         "zjhm": "Số tài liệu",
         "qsrzjhm": "Vui lòng nhập số ID",
         "qpsbsczj": "Hãy chụp ảnh và tải lên ID của bạn",
         "pszm": "Bắn trước",
         "psfm": "Bắn ngược",
         "qsczmz": "Vui lòng tải lên ảnh chính diện",
         "qscfmz": "Vui lòng tải ảnh ngược lên",
         "scqmz": "Đang giữ ảnh có chữ ký",
         "qscqmz": "Vui lòng tải lên ảnh có chữ ký",
         "wyyd": "Tôi đã đọc và hiểu",
         "yhxy": "Thỏa thuận người dùng",
         "grzx": "Trung tâm cá nhân",
         "gnlb": "Danh sách chức năng",
         "smrz": "Xác thực tên thật",
         "rj": "Tiền gửi",
         "cj": "Rút tiền",
         "zhjl": "Hồ sơ tài khoản",
         "xx": "Tin nhắn",
         "wdyq": "Lời mời của tôi",
         "zhaq": "Bảo mật tài khoản",
         "sz": "Cài đặt",
         "lmc": "Tên chuỗi",
         "bcewm": "Lưu mã QR",
         "fzdz": "Sao chép địa chỉ",
         "fzcg": "Sao chép thành công",
         "rjsl": "Số tiền gửi",
         "qsrsl": "Vui lòng nhập số lượng",
         "zdsl": "Số lượng tối thiểu",
         "pzms": "Giá trị băm",
         "qsrpzms": "Vui lòng nhập giá trị băm",
         "lkrj": "Gửi tiền ngay lập tức",
         "cjdz": "Địa chỉ rút tiền",
         "qsrcjdz": "Vui lòng nhập địa chỉ rút tiền",
         "cjsl": "Số tiền rút",
         "qsrcjsl": "Vui lòng nhập số tiền rút",
         "lkcj": "Rút ngay",
         "ddh2": "Số thứ tự:",
         "thời gian": "Thời gian:",
         "je": "Số tiền:",
         "zt": "Trạng thái:",
         "bt": "Tiêu đề:",
         "nr": "Nội dung:",
         "sqz": "Đăng ký",
         "yqhy": "Mời bạn bè",
         "yqhyyqzc": "Mời bạn bè đăng ký cùng",
         "wdyqm": "Mã thư mời của tôi",
         "wdyqlj": "Liên kết thư mời của tôi",
         "fz": "Sao chép",
         "xgdlmm": "Thay đổi mật khẩu đăng nhập",
         "szjymm": "Đặt mật khẩu giao dịch",
         "xgmm": "Thay đổi mật khẩu",
         "tgyzmxgmm": "Thay đổi mật khẩu bằng mã xác nhận",
         "jmm": "mật khẩu cũ",
         "qsrjmm": "Vui lòng nhập mật khẩu cũ",
         "dlmm": "Mật khẩu đăng nhập",
         "qsrdlmm": "Vui lòng nhập mật khẩu đăng nhập",
         "jymm": "Mật khẩu giao dịch",
         "qsrjymm": "Vui lòng nhập mật khẩu giao dịch",
         "mmcd": "Mật khẩu dài 6 chữ số",
         "tcdl": "Đăng xuất",
         "zxkf": "Dịch vụ khách hàng trực tuyến",
         "bzzx": "Trung tâm trợ giúp",
         "ksrm": "Bắt đầu nhanh",
         "kcjg": "Giá vị thế mở",
         "pcjg": "Giá đóng",
         "gdjg": "Giá lệnh chờ",
         "pcfs": "Đóng vị trí",
         "hyl": "Số tiền hợp đồng",
         "thbzj": "Hoàn lại tiền đặt cọc",
         "gmsl": "Số lượng mua",
         "sysl": "Số lượng còn lại",
         "sccg": "Đã lưu thành công",
         "qxdl": "Vui lòng đăng nhập trước",
         "sy": "thu nhập",
         "tj": "Gửi",
         "sfz": "Thẻ căn cước",
         "hz": "Hộ chiếu",
         "jz": "Bằng lái xe",
         "qt": "Khác",
         "qxzmnje": "Vui lòng chọn dung lượng mô phỏng",
         "cjmnzhcg": "Tạo tài khoản demo thành công!",
         "dlmmts": "Vui lòng nhập mật khẩu đăng nhập",
         "mmts": "Độ dài mật khẩu 6-24 chữ số",
         "jymmts": "Mật khẩu dài 6 chữ số",
         "shz": "Đánh giá",
         "shtg": "Đã phê duyệt",
         "jj": "Từ chối",
         "xyb": "Tiếp theo",
         "emailgsts": "Địa chỉ email đã nhập không tuân theo quy tắc",
         "telgsts": "Định dạng của số điện thoại đã nhập không chính xác",
         "lcmmbyz": "Hai mật khẩu đã nhập không nhất quán",
         "gdj": "Giá đặt hàng đang chờ xử lý",
         "lx": "Loại",
         "qsrgdj": "Vui lòng nhập giá lệnh chờ",
         "kccg": "Mở vị thế thành công!",
         "pcsl": "Số lượng đóng",
         "mnts": "Tài khoản ảo đã hết hạn, vui lòng tạo lại",
         "wtfa": "Chế độ ủy quyền",
         "kcsj": "Thời gian mở vị thế",
         "gbsj": "Thời gian đóng",
         "gylx": "Tráo đổi",
         "hyjy": "Hợp đồng",
         "zwsj": "Chưa có dữ liệu",
         "zwkf": "Kênh nạp tiền này chưa được mở",
   },
   "langNew9":{
   "dzje":"Xu hướng thị trường của các sản phẩm giao dịch",
   "lxyxzc":"Bắt đầu hành trình giao dịch kỹ thuật số của bạn",
   "text1":"Bắt đầu bằng cách tạo tài khoản",
   "text2":"Mời bạn bè tham gia MFTG để cùng chơi",
   "text3":"Nạp tiền vào tài khoản của bạn",
   "text4":"Hỗ trợ nhiều lần nạp tiền vào tiền tệ, cho phép bạn nhanh chóng bắt đầu giao dịch",
   "text5":"Bắt đầu giao dịch",
   "text6":"Cung cấp nhiều cặp giao dịch chất lượng cao để lựa chọn và giao dịch vui vẻ tại MFTG",
    "text7":"Mời bạn bè kiếm USDT",
    "text8":"Mời bạn bè kiếm USDT dễ dàng",
    "text9":"Chức năng cho vay trực tuyến",
    "text10":"Khi bạn không có tiền, bạn có thể đăng ký khoản vay, khoản vay sẽ được giải ngân sớm nhất trong ngày",
   "text11":"Giao dịch tất cả các tài sản",
   "text12":"Ngoại hối, tiền điện tử, tương lai, ETF, v.v.",
   },
  "bank":{
    "text1":"Nền tảng quản lý tài chính đáng tin cậy nhất của bạn",
    "text2":"Thông báo tin tức thời gian thực",
    "text3":"Hiểu thông tin thời gian thực về ngành tài chính",
    "text4":"bắt đầu hiểu",
    "text5":"tin tức chớp nhoáng",
    "text6":"Chọn ngân hàng",
    "text7":"thẻ ngân hàng",
    "text8":"Số lượng...",
    "text9":"Thêm thẻ ngân hàng",
    "text10":"tài khoản ngân hàng",
    "text11":"Vui lòng nhập tài khoản ngân hàng",
    "text12":"Mã thẻ",
    "text13":"Vui lòng nhập số ID thẻ",
    "text14":"mã ngân hàng quốc tế",
    "text15":"mã ngân hàng quốc tế",
    "text16":"Vui lòng nhập số điện thoại",
    "text17":"Thêm vào",
    "text18":"Xóa thẻ ngân hàng",
    "text19":"Thực tế đến",
    "text20":"Thông tin rút tiền",
    "text21":"Chọn thẻ ngân hàng",
    "text22":"Ghi chú",
    "text23":"Số tiền rút tối thiểu:",
    "text24":"Không được rút tiền nếu số tiền ít hơn số tiền rút tối thiểu",
    "text25":"• Để đảm bảo an toàn cho tiền, khi chính sách bảo mật tài khoản của bạn thay đổi hoặc mật khẩu thay đổi, chúng tôi sẽ xem xét thủ công việc rút tiền. Vui lòng kiên nhẫn chờ nhân viên liên hệ với bạn qua điện thoại hoặc email.",
    "text26":"• Vui lòng đảm bảo rằng máy tính và trình duyệt của bạn an toàn để tránh thông tin bị giả mạo hoặc rò rỉ.",
    "text27":"• Đối với USD bạn rút, mỗi thao tác có nghĩa là tổng số tài sản hiển thị trên trang rút tiền mà bạn sở hữu sẽ bị giảm đi một lượng tiền rút tương ứng.",
    "text28":"Hồ sơ rút tiền",
    "text29":"Loại tiền pháp định",
  },
   "kxt": {
      "fs": "time",
      "fz":"min",
      "xs":"hour",
      "tian":"day",
      "zhou":"week",
    },
    "xbsg":{
      "title": "Startup",
      "wdsg": "Thông tin chi tiết",
      "scts": "Ngày khóa:",
      "sy": "còn lại",
      "ljsg": "Đăng ký ngay",
      "ysk": "Hết hàng",
      "xzjdy": "Đăng ký ngay",
      "dy": "Đăng ký",
      "fxjg": "Giá phát hành",
      "fxl": "Lưu hành",
      "ssrq": "Ngày niêm yết",
      "yxqx": "Hạn sử dụng",
      "qsrsl": "Vui lòng nhập số lượng",
      "syl": "số tiền còn lại",
      "sgrq": "Ngày mua",
      "sgsl": "Số lượng mua",
      "bz": "Tiền tệ",
      "yebz": "Số dư USDT không đủ",
      "tgsl": "chuyển số lượng",
      "shz": "Đánh giá",
      "wtg": "Thất bại",
      "ytg": "Đã đạt",
      "ffsb": "Phát hành không thành công",
      "yth": "Đã hoàn tiền",
      "sbly": "Lý do thất bại",
      "jjly": "Lý do từ chối",
      "bz2": "Tiền tệ:",
      "fxjg2": "Giá phát hành:",
      "sgsl2": "Số lượng mua:",
      "tgsl2": "Số lượng vượt qua:",
      "sssj": "Đã đến lúc đưa ra thị trường",
      "sssj2": "Thời gian tung ra thị trường:",
      "sgj": "Giá đăng ký",
      "sgj2": "Giá mua:",
      "sgsj": "Thời gian mua hàng",
      "sgsj2": "Thời gian mua hàng:",
      "sbly2": "Lý do lỗi:",
      "jjly2": "Lý do từ chối:",
      "bzj": "Ký quỹ:",
      "zsxf": "Tổng phí giao dịch:",
      "djze": "Tổng số tiền bị đóng băng:",
      "djje": "Số tiền đóng băng"
    },
    "bzhl": {
      "title": "Cổ tức",
      "gz": "Quy định",
      "tgdd": "Lệnh ký quỹ",
      "zztgdzj": "Quỹ giám hộ",
      "yjjrsy": "Thu nhập hôm nay",
      "ljsy": "Tổng doanh thu",
      "tgzdd": "Lệnh giám hộ",
      "cljxcp": "Sản phẩm chiến dịch chiến lược",
      "dbxe": "Hạn mức đơn",
      "rsyl": "Lợi suất hàng ngày",
      "zq": "Chu kỳ",
      "qmr": "Mua ngay",
      "bbzhzc": "Tài sản của tài khoản",
      "dd": "Lệnh",
      "buy": "Mua",
      "jxcp": "Sản phẩm nổi bật",
      "ckdd": "Lệnh kiểm tra",
      "gd": "Xem thêm",
      "xzbzts": "Đơn giản và an toàn. Cổ tức có thể được chọn bằng nhiều loại tiền tệ",
      "qtbz": "Các loại tiền khác",
      "zrsy": "Thu nhập của ngày hôm qua",
      "zdisyl": "Năng suất tối thiểu",
     "zdasyl": "Lợi nhuận tối đa",
     "day": "bầu trời",

     title1: 'Định lượng AI',
     ttzbt: '天天赚不停',
     wdtg: 'Lưu trữ của tôi',
     zztgdzj: 'Quỹ giám hộ',
     yjjrsy: 'Ước tính hàng ngày',
     ljsy: 'Tổng doanh thu',
     tgzdd: 'Lệnh giám hộ',
     tgdd: 'Lệnh ký quỹ',
     t1: 'Rủi ro thấp và quản lý tài chính ổn định, có thể đổi trả bất kỳ lúc nào nếu cần',
     t2: 'Trợ lý quản lý tiền miễn phí của bạn',
     cljxcp: 'Chu kỳ sản phẩm',
     dbxe: 'Hạn mức đơn',
     rsyl: 'Lợi suất hàng ngày(%)',
     rsyl2: 'Lợi suất hàng ngày：',
     zq: 'Chu kỳ',
     qmr: 'Đi mua',
     ckgd: '더보기',
     cpgk: 'Tổng quan về sản phẩm',
     pxsj: 'Thời gian thanh toán cổ tức',
     tgzj: 'Vốn chủ sở hữu giám hộ',
     tqsh: 'Sự chuộc lỗi sớm',
     cpld: 'Những điểm nổi bật của sản phẩm',
     cpgz: 'Quy tắc sản phẩm',
     cont: 'Di chuyển gạch là bằng cách lưu trữ USDT trên nền tảng và đội ngũ chuyên nghiệp của nền tảng có quyền di chuyển gạch. Người tham gia có thể nhận được phần thu nhập từ chuyển gạch của nền tảng trong thời gian lưu ký quỹ. Có thể truy cập vào bất kỳ lúc nào. là an toàn và thuận tiện.',
     zj: 'Tài trợ 100%',
     aqbz: 'Bảo mật',
     jjrsy: 'Thu nhập vào ngày nghỉ lễ',
     bjd: 'Không gián đoạn',
     cgcrh: 'Sau khi ký quỹ thành công',
     dtqx: 'Giá trị lãi suất theo ngày',
     ljzr: 'Chuyển ngay',
     xqglgj: 'Các công cụ quản lý tiền miễn phí',
     ddh: 'Mã số lệnh',
     tgje: 'Số tiền giám hộ',
     tgsj: 'Chu kỳ ngày',
     yhl: 'Đã có lãi',
     xdsj: 'Thời gian đặt lệnh',
     zt: 'trạng thái',
     fh: 'trở về',
     qrnhsy: '七日年化收益',
     ygy: '1个月',
     bn: '半年',
     yn: '1年',
     yuan: '元',
     tzfx: 'rủi ro đầu tư',
     shsc: 'Thời gian đổi thưởng',
     di: 'Thấp',
     yggzr: 'Một ngày làm việc',
     msgsxf: 'Phí đăng ký miễn phí',
     mr: 'Hàng ngày',
     dqfh: 'Hoàn trả khi đến hạn',
     ljgm: 'Mua ngay',
     tgz: 'Giám hộ',
     sh: 'Đổi',
     ywc: 'Đã hoàn tất',
     ysh: 'Đã đổi',
     all: 'Tất cả',
     "xzbzts": "Đơn giản và an toàn. Cổ tức có thể được chọn bằng nhiều loại tiền tệ",
     "qtbz": "Các loại tiền khác"
    },
    "bzhlgm": {
      "qtzq": "Chu kỳ 7 ngày USDT",
      "rsyl": "Lợi suất hàng ngày",
      "lczq": "Chu kỳ tài chính",
      "dbxe": "Hạn mức đơn",
      "pxsj": "Thời gian thanh toán cổ tức",
      "mr": "Hàng ngày",
      "dqfh": "Hoàn trả khi đến hạn",
      "tgzj": "Vốn chủ sở hữu giám hộ",
      "tqsh": "Đổi sớm",
      "yjsy": "Thu nhập dự kiến (USDT)",
      "kyzc": "Tài sản khả dụng(USDT)",
      "cpjs": "Về sản phẩm của chúng tôi",
      "tgje": "Số tiền giám hộ",
      "qsrtgje": "Vui lòng nhập số tiền giám hộ",
      "qb": "Tất cả",
      "rm": "Mua ngay",
      "cpzq": "Chu kỳ sản phẩm",
      "gz": "Hiểu rõ quy định và lợi ích",
      "ktgje": "Số tiền có thể ký quỹ: ",
    },
    "bzhlwdtg": {
      "title": "Trạng thái lệnh",
      "tgz": "Giám hộ",
      "ywc": "Đã hoàn tất",
      "ysh": "Đã đổi",
      "tgje": "Số tiền giám hộ/Thời gian giám hộ",
      "rsyl": "Lợi suất hàng ngày",
      "yhl": "Đã có lãi",
      "xdsj": "Thời gian đặt lệnh",
      "sh": "Đổi",
      "ddxq": "Chi tiết lệnh",
      "ddh": "Mã số lệnh"
    },
    "bzjj": {
      "t1": "Thu nhập mỗi ngày",
      "cpld": "Những điểm nổi bật của sản phẩm",
      "scsq": "Ký quỹ & lấy về bất kỳ lúc nào",
      "pxzq": "Chu kỳ cổ tức",
      "mtxf": "Phân phối hàng ngày",
      "hqlx": "Lãi suất hiện thời",
      "zj": "Tài trợ 100%",
      "aqbz": "Bảo mật",
      "jjrsy": "Thu nhập vào ngày nghỉ lễ",
      "sybjd": "Lợi nhuận liên tục",
      "bjd": "Không gián đoạn",
      "cgcrh": "Sau khi ký quỹ thành công",
      "dtqx": "Giá trị lãi suất theo ngày",
      "jglz": "Ví dụ",
      "syjs": "Tính toán doanh thu",
      "cont2": "Tối thiểu: 10000U x 0,3%=30U",
      "cont3": "Tối đa: 10000U x 0,5%=50U",
      "gywyj": "Về thiệt hại thanh khoản",
      "wycy": "Tôi muốn tham gia"
    },
    "wydb": {
      "title": "Tôi muốn vay tiền",
      "db": "Tiền tệ",
      "dbz": "bằng tiền tệ",
      "jl": "Ghi lại",
      "jdzq": "Thời gian cho vay (ngày)",
      "qhk": "Đi trả nợ",
      "ljdb": "Tiền tệ cho vay tích lũy (usdt)",
      "dhkbs" : "Số khoản thanh toán đang chờ xử lý",
      "jkje": "Số tiền vay (usdt)",
      "qsrje": "Vui lòng nhập số tiền",
      "rll": "Tỷ lệ hàng ngày",
      "hkfs": "Phương thức trả nợ",
      "dqych": "Trả gốc và lãi khi đến hạn",
      "lx": "Lãi suất",
      "fkjg": "Tổ chức cho vay",
      "tpsc": "Khoản vay tín dụng (hình ảnh tải lên)",
      "fwxx": "Thông tin nhà",
      "srzm": "Bằng chứng thu nhập",
      "yhmx": "Chi tiết ngân hàng",
      "qscfwxx": "Vui lòng tải lên thông tin nhà ở",
      "qscsrzm": "Vui lòng tải lên bằng chứng thu nhập",
      "qscyhmx": "Vui lòng tải lên chi tiết ngân hàng",
      "qsczjz": "Vui lòng tải lên ảnh ID",
      "zjz": "Ảnh ID",
      "yd": "Tôi đã đọc và đồng ý",
      "xy": "Hợp đồng cho vay ứng dụng",
      "sqdb": "Nhấp để đăng ký vay",
      "gb": "đóng",
      "qd": "Được",
      "ts": "Vui lòng kiểm tra hợp đồng vay ứng dụng",
      "dbjl": "Hồ sơ Khoản vay",
      "hkhth": "Số hợp đồng vay",
      "wsh": "chưa được xem xét",
      "yfk": "Đã giải ngân",
      "sqrq": "Ngày nộp đơn",
      "zq": "dấu chấm",
      "dbsl": "Số tiền cho vay",
      "zhke": "Tổng số tiền trả nợ",
      "yhkxq": "Chi tiết trả nợ",
      "bqyhk": "Khoản thanh toán đến hạn trong kỳ này (USDT)",
      "hktips": "Hãy đảm bảo rằng số dư đủ, nếu số dư không đủ, vui lòng nạp tiền trước khi trả nợ",
      "bj": "Hiệu trưởng",
      "jie": "mượn",
      "ljhk": "Trả ngay",
      "qcz": "Đi nạp tiền",
      "yebzqxcz": "Không đủ số dư, vui lòng nạp tiền trước khi trả nợ",
      "znj": "Phí trả chậm",
      "yqts": "Số ngày quá hạn",
      "kjdje": "Số tiền có thể vay",
      "rlxl": "Lãi suất hàng ngày",
      "rlxl2": "Lãi suất hàng ngày:",
      "yqll": "Lãi suất hoãn lại",
      "yqll2": "Lãi suất trả chậm:",
      "ljlx": "Lãi tích lũy",
      "zrlx": "Lãi suất hôm qua",
      "jddd": "Lệnh cho vay",
      "zxje": "Số tiền tối thiểu:",
      "jexz": "Giới hạn số tiền:",
      "xypztp": "Hình ảnh xác thực:",
      "hkpztp": "Hình ảnh chứng từ thanh toán:",
      "ysxsl": "Số tiền lãi kiếm được:",
      "ysxts": "Số ngày đã tích lũy tiền lãi:",
      "jdsl": "Số tiền vay:",
      "fkjg2": "Tổ chức cho vay:",
      "zq2": "Thời gian:",
      "sqrq2": "Ngày đăng ký:",
      "zhke2": "Tổng số tiền trả nợ:",
      "yff": "đã ban hành",
      "hkz": "Trả nợ",
      "yjq": "Đã xóa",
      "jjdk": "Từ chối khoản vay",
      "ch": "Rút tiền",
      "cxsq": "Đăng ký lại",
      "hdgz": "Quy định của sự kiện"
    },
    "xyf": {
      "title": "Điểm tín dụng",
      "dqxyf": "Điểm tín dụng hiện tại",
      "hwqxyf": "Bạn chưa nhận được điểm tín dụng",
      "zwxyf": "Chưa có điểm tín dụng",
      "pgsj": "Thời gian đánh giá",
      "xypz": "Thông tin xác thực (hình ảnh tải lên)",
      "cxtjsh": "Gửi lại để xem xét",
      "tjsh": "Gửi để xem xét",
      "yjj": "Bị từ chối",
      "hq": "Nhận",
      "qx": "Hủy bỏ",
      "qxwcsmrz": "Hoàn thành xác thực tên thật trước"
    },
    "hkxq":{
      "đ": "Đặt hàng",
      "fzhkdz": "Sao chép địa chỉ trả nợ",
      "hkxq": "Chi tiết trả nợ",
      "zlx": "Tổng tiền lãi",
      "zhk": "Tổng số tiền phải trả",
      "hkjg": "Đại lý trả nợ",
      "qschkpz": "Vui lòng tải lên chứng từ trả nợ",
      "hkpz": "Phiếu thanh toán",
      "lxkfhk": "Liên hệ dịch vụ khách hàng để hoàn trả"
    },
    "tipsNew":{
      "wjmmts": "Khôi phục mật khẩu bằng mã xác minh",
      "qscpztp": "Tải lên hình ảnh phiếu thưởng",
      "emailgsts": "Vui lòng nhập email hợp lệ",
      "telgsts": "Số điện thoại di động không chính xác",
      "lcmmbyz": "Vui lòng xác nhận mật khẩu của bạn",
      "zdsl": "Số tiền tối thiểu ",
      "sldydy": "Số lượng lớn hơn hoặc bằng",
      "zxtzsl": "Số tiền đầu tư tối thiểu ",
      "ddz": "Đang chờ đợi",
      "xs": "Giờ",
      "min": "Số tiền tối thiểu ",
      "max": "Số tiền tối đa ",
      "yebz": "Thiếu cân bằng",
      "qsrss": "Vui lòng nhập lô",
      "zdss": "Số lô tối thiểu",
      "yjj": "từ chối",
      "shz": "chuộc lỗi"
    },
    "status":{
      "statusText": ['sự thất bại','Đang chờ được xử lý','sự thành công'],
    },
    "jghy": {
      "jghy": "Hoán đổi",
      "yxhy": "Hợp đồng vĩnh viễn",
      "mz": "Tăng giá",
      "md": "Giảm giá",
      "gmj": "Giá mua",
      "jsj": "Giá thanh toán",
      "xj": "Giá hiện thời",
      "fx": "Xu hướng",
      "sl": "Số lượng",
      "jgsj": "Thời gian giao",
      "gb": "Đóng",
      "jxxd": "Tiếp tục đặt lệnh",
      "cclb": "Danh sách lệnh",
      "zc": "Hiện thời",
      "lscc": "Lịch sử",
      "qblx": "Tất cả các loại",
      "yk": "Lãi và lỗ",
      "ddqr": "Xác nhận lệnh",
      "dqsj": "Thời gian hết hạn",
      "jssj": "Thời gian giao",
      "sy": "Lãi",
      "tzje": "Số tiền đầu tư",
      "zdje": "Giá thấp nhất 0",
      "kyye": "Có sẵn",
      "sxf": "phí xử lý",
      "sxfl": "Tỷ lệ thủ tục",
      "jypz": "Cặp",
      "jyfx": "Xu hướng",
      "qrxd": "Xác nhận",
      "dqye": "Số dư hiện thời",
      "zt": "Trạng thái"
    },
    "bbjy":{
      "cjsj":"Thời gian giao dịch",
      "wtjg":"Giá hoa hồng",
      "cjjg":"Giá giao dịch",
      "wcj":"Không có giao dịch",
      "ycj":"Giao dịch đã hoàn tất",
      "yqx":"Đã hủy",
      "qxwt":"Hủy ủy quyền",
      "qsrxj":"Vui lòng nhập giá giới hạn"
    }
}



// WEBPACK FOOTER //
// ./src/lang/yn.js